export const PAGE_CONFIG = {
  "title": "KPI Overview",
  "titleCN": "KPI 总览",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/overview/kpi",
  "defaultTab": "kpi",
  "tabList": [
    {
      "id": "kpi",
      "tabName": "KPI Overview",
      "tabNameCN": "KPI 总览",
      "isHaveNotification": true,
      "notificationPath": "/overview/kpi",
      "path": "/overview/kpi",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "209101",
        "pageName": "kpiOverview",
        "extInfo": "kpiOverview",
        "pagePath": "/overview/kpi"
      },
      "filters": [
        {
          "name": "kpiOverViewFIlter",
          "isOpenSticky": true,
          "segmentFloatStickySyncId": "kpi-overview-segment-filter",
          "isHaveFilterSave": true,
          "filterPath": "/overview/kpi",
          "className": "dbd-kpi-overview-filter",
          "timeZone": "-4",
          "kpiEventDataSource": {
            "api": "/api/v1/dashboard/pc/event_analysis_v2/trend_event_list",
            "mergeConsecutiveTrendDays": false,
            "removeEventNumLimit": true,
            "filterEventDateField": "start_time",
            "excludeEventTypes": ["Holiday"],
            "minTrendRangeDays": 30
          },
          "kpiEventFilterLanguage": {
            "checkboxLabelZh": "显示事件",
            "checkboxLabelEn": "Show Events"
          },
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "KpiOverviewEventDataBridge",
                  "className": "",
                  "type": "view",
                  "style": {
                    "marginTop": "10px"
                  },
                  "children": [
                    {
                      "name": "AnomalyService",
                      "props": {
                        "disableAnomalyRequest": false,
                        "config": {
                          "anomalMinTrendRangeDays": 30
                        }
                      },
                      "children": [
                        {
                          "name": "KpiAiSummaryService",
                          "props": {
                            "enabled": true,
                            "api": "/api/v1/dashboard/pc/overview_daily/anomaly_ai_summary",
                            "dataKey": "ai_summary",
                            "trackData": [
                              "gameCode"
                            ],
                            "formatData": "function(res) {\n                                                            var d = res === null || res === void 0 ? void 0 : res.data;\n                                                            return d && Object.keys(d).length > 0 ? d : null;\n                                                        }",
                            "beforeRequest": "function(data) {\n                                                            var fv = (data === null || data === void 0 ? void 0 : data.filterVal) ? data.filterVal : {};\n                                                            var rangeTime = fv.rangeTime;\n                                                            var isSingleDay = Array.isArray(rangeTime) && rangeTime.length >= 2 && String(rangeTime[0]) === String(rangeTime[1]);\n                                                            var isObject = function(val) {\n                                                                return Object.prototype.toString.call(val) === '[object Object]';\n                                                            };\n                                                            var getList = function(key, v) {\n                                                                if (Array.isArray(v)) return v;\n                                                                if (isObject(v)) {\n                                                                    if (key === 'region') {\n                                                                        var markets = v.markets;\n                                                                        return Array.isArray(markets) ? markets : undefined;\n                                                                    }\n                                                                    var val = v[key];\n                                                                    return Array.isArray(val) ? val : undefined;\n                                                                }\n                                                                return undefined;\n                                                            };\n                                                            var isDef = function(list) {\n                                                                return !list || list.length === 0 || list.length === 1 && (list[0] === 255 || list[0] === '255');\n                                                            };\n                                                            var dimKeys = [\n                                                                'system',\n                                                                'campaign',\n                                                                'ua_network',\n                                                                'region'\n                                                            ];\n                                                            var hasChangedDim = dimKeys.some(function(k) {\n                                                                return !isDef(getList(k, fv[k]));\n                                                            });\n                                                            if (!isSingleDay || hasChangedDim) {\n                                                                return false;\n                                                            }\n                                                            var result = {};\n                                                            Object.assign(result, {\n                                                                game_code: data.gameCode\n                                                            });\n                                                            if (Array.isArray(rangeTime)) {\n                                                                Object.assign(result, {\n                                                                    time: rangeTime[1]\n                                                                });\n                                                            }\n                                                            return result;\n                                                        }"
                          },
                          "children": [
                            {
                              "name": "AiAnalysisGuard",
                              "children": [
                                {
                                  "name": "MarkDownCard",
                                  "className": "margin-t-20 dbd-markdown-card-title-black margin-b-20",
                                  "data": {
                                    "subtitle": ""
                                  },
                                  "props": {
                                    "titleEn": "AI Analysis",
                                    "titleCn": "AI分析总结",
                                    "titleIcon": "ai-color-robot",
                                    "content": "{{data.overall_summary.ai_info}}",
                                    "updateDate": "{{data.overall_summary.date}}",
                                    "subtitleEn": "{{subtitle}}",
                                    "subtitleCn": "{{subtitle}}",
                                    "infoType": "{{data.overall_summary.ai_info_type}}",
                                    "htmlKey": "html",
                                    "linkOpenInNewWindow": true
                                  }
                                }
                              ]
                            },
                            {
                              "name": "SegmentScrollCo",
                              "className": "dbd-kpi-overview-segment-scroll-co",
                              "props": {
                                "config": {
                                  "variant": "floating",
                                  "segmentFloatStickySyncId": "kpi-overview-segment-filter",
                                  "floatHeaderStickyDelayMs": 200,
                                  "showDownloadBtn": true,
                                  "componentSegment": [
                                    {
                                      "value": "kpi_progress",
                                      "enName": "KPI Progress",
                                      "cnName": "KPI 进度"
                                    },
                                    {
                                      "value": "ua_team",
                                      "enName": "UA Team",
                                      "cnName": "UA 团队"
                                    },
                                    {
                                      "value": "dev_team",
                                      "enName": "R&D Team",
                                      "cnName": "产研团队"
                                    },
                                    {
                                      "value": "commercial_team",
                                      "enName": "Monetization Team",
                                      "cnName": "商业化团队"
                                    },
                                    {
                                      "value": "creative_team",
                                      "enName": "Creative Team",
                                      "cnName": "素材团队"
                                    },
                                    {
                                      "value": "region_team",
                                      "enName": "Regional Team",
                                      "cnName": "区域团队"
                                    }
                                  ],
                                  "scrollMarginTop": 65,
                                  "observerThreshold": 0.1
                                }
                              },
                              "children": [
                                {
                                  "name": "SegmentScrollChildrenWrapper",
                                  "id": "kpi_progress",
                                  "children": [
                                    {
                                      "name": "Service",
                                      "props": {
                                        "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                                        "dataKey": "kpiProgressData",
                                        "trackData": [
                                          "extraParams",
                                          "gameCode"
                                        ],
                                        "beforeRequest": "function(data) {\n  var f = (data && data.filterVal) || {};\n  var rt = f.rangeTime || [];\n  var drt = f.defaultRangeTime || [];\n  var isA=function(v){return !v||(Array.isArray(v)&&(v.length===0||(v.length===1&&v[0]==='255')));};\n  var rg2=f.region||{};var ua2=f.ua_network||{};var cp2=f.campaign||{};\n  var dateDef=drt.length>=2&&String(rt[0])===String(drt[0])&&String(rt[1])===String(drt[1]);\n  var allDef=dateDef&&isA(f.zone)&&isA(f.system)&&isA(f.channel)&&isA(f.lang)&&isA(rg2.markets||rg2)&&isA(ua2.ua_network||ua2)&&isA(cp2.campaign||cp2);\n  if(!allDef) return false;\n  var endDate = rt[1] || rt[0] || '';\n  var ua = f.ua_network || {};\n  var cp = f.campaign || {};\n  var rg = f.region || {};\n  return {\n    game_code: data.gameCode,\n    period: 'daily',\n    start_time: endDate,\n    end_time: endDate,\n    is_confirm: false,\n    filters: {\n      zone_list: f.zone || ['255'],\n      channel_list: f.channel || ['255'],\n      market_list: rg.markets || ['255'],\n      os_list: f.system || ['255'],\n      lang_list: f.lang || ['255'],\n      custom_filters: [\n        { key: 'version', filter_list: f.version || ['255'] },\n        { key: 'ua_network', filter_list: ua.ua_network || ['255'] },\n        { key: 'user_type', filter_list: f.user_type || ['255'] },\n        { key: 'campaign', filter_list: cp.campaign || ['255'] },\n        { key: 'network_type', filter_list: f.network_type || ['255'] }\n      ]\n    },\n    metrics: ['kpi_target_revenue', 'kpi_target_total_spend', 'kpi_ua_roi_spend', 'kpi_ua_low_cpi_spend', 'kpi_target_ua_roi_spend', 'kpi_target_ua_low_cpi_spend', 'kpi_target_total_install', 'kpi_ua_roi_install', 'kpi_target_ua_roi_install', 'kpi_ua_low_cpi_install', 'kpi_target_ua_low_cpi_install', 'kpi_ua_pre_install_install', 'kpi_target_ua_pre_install_install', 'kpi_marketing_and_region_install', 'kpi_target_marketing_and_region_install', 'kpi_joint_operation_install', 'kpi_target_joint_operation_install', 'kpi_target_total_max_dau', 'kpi_ua_roi_max_dau', 'kpi_target_ua_roi_max_dau', 'kpi_ua_low_cpi_max_dau', 'kpi_target_ua_low_cpi_max_dau', 'kpi_ua_pre_install_max_dau', 'kpi_target_ua_pre_install_max_dau', 'kpi_marketing_and_region_max_dau', 'kpi_target_marketing_and_region_max_dau', 'kpi_joint_operation_max_dau', 'kpi_target_joint_operation_max_dau']\n  };\n}",
                                        "formatData": "function(data) {\n  var cardList = (data && data.card_list) || [];\n  var map = {};\n  cardList.forEach(function(item) { map[item.metrics_name] = item; });\n  return map;\n}"
                                      },
                                      "children": [
                                        {
                                          "name": "Service",
                                          "props": {
                                            "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                                            "dataKey": "mtdProgressData",
                                            "trackData": [
                                              "extraParams",
                                              "gameCode"
                                            ],
                                            "beforeRequest": "function(data) {\n  var f = (data && data.filterVal) || {};\n  var rt = f.rangeTime || [];\n  var endDate = rt[1] || rt[0] || '';\n  var ua = f.ua_network || {};\n  var cp = f.campaign || {};\n  var rg = f.region || {};\n  return {\n    game_code: data.gameCode,\n    period: 'daily',\n    start_time: endDate,\n    end_time: endDate,\n    is_confirm: false,\n    filters: {\n      zone_list: f.zone || ['255'],\n      channel_list: f.channel || ['255'],\n      market_list: rg.markets || ['255'],\n      os_list: f.system || ['255'],\n      lang_list: f.lang || ['255'],\n      custom_filters: [\n        { key: 'version', filter_list: f.version || ['255'] },\n        { key: 'ua_network', filter_list: ua.ua_network || ['255'] },\n        { key: 'user_type', filter_list: f.user_type || ['255'] },\n        { key: 'campaign', filter_list: cp.campaign || ['255'] },\n        { key: 'network_type', filter_list: f.network_type || ['255'] }\n      ]\n    },\n    metrics: ['mtd_iaa_revenue', 'mtd_ug_spend', 'mtd_ug_install', 'mtd_max_active_users']\n  };\n}",
                                            "formatData": "function(data) {\n  var cardList = (data && data.card_list) || [];\n  var map = {};\n  cardList.forEach(function(item) { map[item.metrics_name] = item; });\n  return map;\n}"
                                          },
                                          "children": [
                                            {
                                              "name": "KpiFilterGuard",
                                              "props": {
                                                "showWhenDefault": true
                                              },
                                              "children": [
                                                {
                                                  "name": "CommonRow",
                                                  "className": "margin-b-10 margin-t-10",
                                                  "children": [
                                                    {
                                                      "name": "CommonCol",
                                                      "props": {
                                                        "w": 12
                                                      },
                                                      "children": [
                                                        {
                                                          "name": "KpiSummaryCard",
                                                          "props": {
                                                            "titleCn": "月收入",
                                                            "titleEn": "Monthly Revenue",
                                                            "valueMetric": "mtd_iaa_revenue",
                                                            "targetMetric": "kpi_target_revenue",
                                                            "formatRule": "thousands2Decimal",
                                                            "targetFormatRule": "thousandsInit",
                                                            "icon": "money",
                                                            "preUnit": "$",
                                                            "clickable": true,
                                                            "jumpUrl": "/dashboard/game/iaa_mpp/overview/daily?rangeDateKey=rangeDaily&start={{monthFirst}}&end={{endDate}}",
                                                            "dataKey": "kpiProgressData",
                                                            "valueDataKey": "mtdProgressData",
                                                            "targetDataKey": "kpiProgressData",
                                                            "targetProgressFilterOverrides": [
                                                              {
                                                                "filterKey": "system",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              },
                                                              {
                                                                "filterKey": "campaign",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              },
                                                              {
                                                                "filterKey": "ua_network",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              },
                                                              {
                                                                "filterKey": "region",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              }
                                                            ],
                                                            "hiddenTargetModulesWhenFilterMismatch": [
                                                              "target",
                                                              "extraMetrics",
                                                              "circleChart"
                                                            ]
                                                          }
                                                        }
                                                      ]
                                                    },
                                                    {
                                                      "name": "CommonCol",
                                                      "props": {
                                                        "w": 12
                                                      },
                                                      "children": [
                                                        {
                                                          "name": "KpiSummaryCard",
                                                          "props": {
                                                            "titleCn": "月花费",
                                                            "titleEn": "Monthly Spend",
                                                            "valueMetric": "mtd_ug_spend",
                                                            "targetMetric": "kpi_target_total_spend",
                                                            "formatRule": "thousands2Decimal",
                                                            "targetFormatRule": "thousandsInit",
                                                            "preUnit": "$",
                                                            "icon": "money",
                                                            "dataKey": "kpiProgressData",
                                                            "valueDataKey": "mtdProgressData",
                                                            "targetDataKey": "kpiProgressData",
                                                            "extraMetricsDataKey": "kpiProgressData",
                                                            "extraMetrics": [
                                                              {
                                                                "labelCn": "UA-ROI",
                                                                "labelEn": "UA-ROI",
                                                                "valueMetric": "kpi_ua_roi_spend",
                                                                "targetMetric": "kpi_target_ua_roi_spend",
                                                                "formatRule": "thousands2Decimal"
                                                              },
                                                              {
                                                                "labelCn": "UA-CPI",
                                                                "labelEn": "UA-CPI",
                                                                "valueMetric": "kpi_ua_low_cpi_spend",
                                                                "targetMetric": "kpi_target_ua_low_cpi_spend",
                                                                "formatRule": "thousands2Decimal"
                                                              }
                                                            ],
                                                            "targetProgressFilterOverrides": [
                                                              {
                                                                "filterKey": "system",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              },
                                                              {
                                                                "filterKey": "campaign",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              },
                                                              {
                                                                "filterKey": "ua_network",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              },
                                                              {
                                                                "filterKey": "region",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              }
                                                            ],
                                                            "hiddenTargetModulesWhenFilterMismatch": [
                                                              "target",
                                                              "extraMetrics",
                                                              "circleChart"
                                                            ]
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  ]
                                                },
                                                {
                                                  "name": "CommonRow",
                                                  "children": [
                                                    {
                                                      "name": "CommonCol",
                                                      "props": {
                                                        "w": 12
                                                      },
                                                      "children": [
                                                        {
                                                          "name": "KpiProgressDetailCard",
                                                          "props": {
                                                            "titleCn": "月新进",
                                                            "titleEn": "Monthly New",
                                                            "summaryValueMetrics": [
                                                              "kpi_ua_roi_install",
                                                              "kpi_ua_low_cpi_install",
                                                              "kpi_ua_pre_install_install",
                                                              "kpi_marketing_and_region_install",
                                                              "kpi_joint_operation_install"
                                                            ],
                                                            "summaryTargetMetric": "kpi_target_total_install",
                                                            "summaryValueDataKey": "kpiProgressData",
                                                            "summaryTargetDataKey": "kpiProgressData",
                                                            "formatRule": "thousandsInit",
                                                            "dataKey": "kpiProgressData",
                                                            "icon": "user-plus",
                                                            "targetProgressFilterOverrides": [
                                                              {
                                                                "filterKey": "system",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              },
                                                              {
                                                                "filterKey": "campaign",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              },
                                                              {
                                                                "filterKey": "ua_network",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              },
                                                              {
                                                                "filterKey": "region",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              }
                                                            ],
                                                            "hiddenTableColumnCodesWhenFilterMismatch": [
                                                              "target",
                                                              "progress"
                                                            ],
                                                            "hiddenTargetModulesWhenFilterMismatch": [
                                                              "summaryTargetRow",
                                                              "summaryCircle"
                                                            ],
                                                            "tableColumns": [
                                                              {
                                                                "code": "category",
                                                                "nameCn": "分类",
                                                                "nameEn": "Category",
                                                                "tipsCn": "1.UA汇总：UA-ROI、UA-CPI、UA-云预装三者之和\n2.UA-ROI型：以ROAS回本为目标的UA投放\n3.UA-CPI型：以用户量为目标的UA投放（不追求回本）\n4.UA-云预装：预装渠道\n5.自然量（市场&区域）：市场及区域团队的目标为自然量级\n6.联运：小米、vivo、传音等海外商店联运渠道",
                                                                "tipsEn": "1.UA Total：UA-ROI、UA-CPI、UA-云预装三者之和\n2.UA-ROI: 以ROAS回本为目标的UA投放\n3.UA-CPI: 以用户量为目标的UA投放(不追求回本)\n4.UA Pre-install: 预装渠道\n5.Organic Traffic (Market & Regional): 市场&区域团队的目标为自然量级\n6.Co-publishing :小米、vivo、传音等海外商店联运渠道"
                                                              },
                                                              {
                                                                "code": "value",
                                                                "nameCn": "月新进",
                                                                "nameEn": "Monthly New",
                                                                "formatRule": "thousandsInit",
                                                                "sortable": true
                                                              },
                                                              {
                                                                "code": "target",
                                                                "nameCn": "目标",
                                                                "nameEn": "Target",
                                                                "formatRule": "thousandsInit",
                                                                "sortable": true
                                                              },
                                                              {
                                                                "code": "progress",
                                                                "nameCn": "进度",
                                                                "nameEn": "Progress",
                                                                "sortable": true
                                                              }
                                                            ],
                                                            "tableRows": [
                                                              {
                                                                "categoryCn": "UA汇总",
                                                                "categoryEn": "UA Total",
                                                                "valueMetric": "mtd_ug_install",
                                                                "targetMetric": "kpi_target_total_install",
                                                                "aggregateFrom": {
                                                                  "valueMetrics": [
                                                                    "kpi_ua_roi_install",
                                                                    "kpi_ua_low_cpi_install",
                                                                    "kpi_ua_pre_install_install"
                                                                  ],
                                                                  "targetMetrics": [
                                                                    "kpi_target_ua_roi_install",
                                                                    "kpi_target_ua_low_cpi_install",
                                                                    "kpi_target_ua_pre_install_install"
                                                                  ]
                                                                }
                                                              },
                                                              {
                                                                "categoryCn": "UA ROI",
                                                                "categoryEn": "UA ROI",
                                                                "valueMetric": "kpi_ua_roi_install",
                                                                "targetMetric": "kpi_target_ua_roi_install"
                                                              },
                                                              {
                                                                "categoryCn": "UA-CPI",
                                                                "categoryEn": "UA-CPI",
                                                                "valueMetric": "kpi_ua_low_cpi_install",
                                                                "targetMetric": "kpi_target_ua_low_cpi_install"
                                                              },
                                                              {
                                                                "categoryCn": "UA-云预装",
                                                                "categoryEn": "UA Pre-install",
                                                                "valueMetric": "kpi_ua_pre_install_install",
                                                                "targetMetric": "kpi_target_ua_pre_install_install"
                                                              },
                                                              {
                                                                "categoryCn": "市场&区域",
                                                                "categoryEn": "Market & Region",
                                                                "valueMetric": "kpi_marketing_and_region_install",
                                                                "targetMetric": "kpi_target_marketing_and_region_install"
                                                              },
                                                              {
                                                                "categoryCn": "联运",
                                                                "categoryEn": "Joint Operation",
                                                                "valueMetric": "kpi_joint_operation_install",
                                                                "targetMetric": "kpi_target_joint_operation_install"
                                                              }
                                                            ]
                                                          }
                                                        }
                                                      ]
                                                    },
                                                    {
                                                      "name": "CommonCol",
                                                      "props": {
                                                        "w": 12
                                                      },
                                                      "children": [
                                                        {
                                                          "name": "KpiProgressDetailCard",
                                                          "props": {
                                                            "titleCn": "月峰值DAU",
                                                            "titleEn": "Monthly Peak DAU",
                                                            "summaryValueMetric": "mtd_max_active_users",
                                                            "summaryTargetMetric": "kpi_target_total_max_dau",
                                                            "summaryValueDataKey": "mtdProgressData",
                                                            "summaryTargetDataKey": "kpiProgressData",
                                                            "formatRule": "thousandsInit",
                                                            "dataKey": "kpiProgressData",
                                                            "icon": "user-ua",
                                                            "targetProgressFilterOverrides": [
                                                              {
                                                                "filterKey": "system",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              },
                                                              {
                                                                "filterKey": "campaign",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              },
                                                              {
                                                                "filterKey": "ua_network",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              },
                                                              {
                                                                "filterKey": "region",
                                                                "values": [
                                                                  "255"
                                                                ]
                                                              }
                                                            ],
                                                            "hiddenTableColumnCodesWhenFilterMismatch": [
                                                              "target",
                                                              "progress"
                                                            ],
                                                            "hiddenTargetModulesWhenFilterMismatch": [
                                                              "summaryTargetRow",
                                                              "summaryCircle"
                                                            ],
                                                            "tableColumns": [
                                                              {
                                                                "code": "category",
                                                                "nameCn": "分类",
                                                                "nameEn": "Category",
                                                                "tipsCn": "1.UA汇总：UA-ROI、UA-CPI、UA-云预装三者之和\n2.UA-ROI型：以ROAS回本为目标的UA投放\n3.UA-CPI型：以用户量为目标的UA投放（不追求回本）\n4.UA-云预装：预装渠道\n5.自然量（市场&区域）：市场及区域团队的目标为自然量级\n6.联运：小米、vivo、传音等海外商店联运渠道",
                                                                "tipsEn": "1.UA Total：UA-ROI、UA-CPI、UA-云预装三者之和\n2.UA-ROI: 以ROAS回本为目标的UA投放\n3.UA-CPI: 以用户量为目标的UA投放(不追求回本)\n4.UA Pre-install: 预装渠道\n5.Organic Traffic (Market & Regional): 市场&区域团队的目标为自然量级\n6.Co-publishing :小米、vivo、传音等海外商店联运渠道"
                                                              },
                                                              {
                                                                "code": "value",
                                                                "nameCn": "月峰值DAU",
                                                                "nameEn": "Monthly Peak DAU",
                                                                "formatRule": "thousandsInit",
                                                                "sortable": true
                                                              },
                                                              {
                                                                "code": "target",
                                                                "nameCn": "目标",
                                                                "nameEn": "Target",
                                                                "formatRule": "thousandsInit",
                                                                "sortable": true
                                                              },
                                                              {
                                                                "code": "progress",
                                                                "nameCn": "进度",
                                                                "nameEn": "Progress",
                                                                "sortable": true
                                                              }
                                                            ],
                                                            "tableRows": [
                                                              {
                                                                "categoryCn": "UA汇总",
                                                                "categoryEn": "UA Total",
                                                                "valueMetric": "mtd_max_active_users",
                                                                "targetMetric": "kpi_target_total_max_dau",
                                                                "aggregateFrom": {
                                                                  "valueMetrics": [
                                                                    "kpi_ua_roi_max_dau",
                                                                    "kpi_ua_low_cpi_max_dau",
                                                                    "kpi_ua_pre_install_max_dau"
                                                                  ],
                                                                  "targetMetrics": [
                                                                    "kpi_target_ua_roi_max_dau",
                                                                    "kpi_target_ua_low_cpi_max_dau",
                                                                    "kpi_target_ua_pre_install_max_dau"
                                                                  ]
                                                                }
                                                              },
                                                              {
                                                                "categoryCn": "UA ROI",
                                                                "categoryEn": "UA ROI",
                                                                "valueMetric": "kpi_ua_roi_max_dau",
                                                                "targetMetric": "kpi_target_ua_roi_max_dau"
                                                              },
                                                              {
                                                                "categoryCn": "UA-CPI",
                                                                "categoryEn": "UA-CPI",
                                                                "valueMetric": "kpi_ua_low_cpi_max_dau",
                                                                "targetMetric": "kpi_target_ua_low_cpi_max_dau"
                                                              },
                                                              {
                                                                "categoryCn": "UA-云预装",
                                                                "categoryEn": "UA Pre-install",
                                                                "valueMetric": "kpi_ua_pre_install_max_dau",
                                                                "targetMetric": "kpi_target_ua_pre_install_max_dau"
                                                              },
                                                              {
                                                                "categoryCn": "市场&区域",
                                                                "categoryEn": "Market & Region",
                                                                "valueMetric": "kpi_marketing_and_region_max_dau",
                                                                "targetMetric": "kpi_target_marketing_and_region_max_dau"
                                                              },
                                                              {
                                                                "categoryCn": "联运",
                                                                "categoryEn": "Joint Operation",
                                                                "valueMetric": "kpi_joint_operation_max_dau",
                                                                "targetMetric": "kpi_target_joint_operation_max_dau"
                                                              }
                                                            ]
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  ]
                                                }
                                              ]
                                            },
                                            {
                                              "name": "KpiFilterGuard",
                                              "props": {
                                                "showWhenDefault": false
                                              },
                                              "children": [
                                                {
                                                  "name": "CommonRow",
                                                  "className": "margin-t-10",
                                                  "children": [
                                                    {
                                                      "name": "CommonCol",
                                                      "props": {
                                                        "w": 8
                                                      },
                                                      "children": [
                                                        {
                                                          "name": "KpiSummaryCard",
                                                          "props": {
                                                            "titleCn": "月收入",
                                                            "titleEn": "Monthly Revenue",
                                                            "valueMetric": "mtd_iaa_revenue",
                                                            "formatRule": "thousands2Decimal",
                                                            "preUnit": "$",
                                                            "icon": "money",
                                                            "valueDataKey": "mtdProgressData",
                                                            "hiddenTargetModules": [
                                                              "target",
                                                              "extraMetrics",
                                                              "circleChart"
                                                            ],
                                                            "className": "dbd-kpi-card--compact"
                                                          }
                                                        }
                                                      ]
                                                    },
                                                    {
                                                      "name": "CommonCol",
                                                      "props": {
                                                        "w": 8
                                                      },
                                                      "children": [
                                                        {
                                                          "name": "KpiSummaryCard",
                                                          "props": {
                                                            "titleCn": "月花费",
                                                            "titleEn": "Monthly Spend",
                                                            "valueMetric": "mtd_ug_spend",
                                                            "formatRule": "thousands2Decimal",
                                                            "preUnit": "$",
                                                            "icon": "money",
                                                            "valueDataKey": "mtdProgressData",
                                                            "hiddenTargetModules": [
                                                              "target",
                                                              "extraMetrics",
                                                              "circleChart"
                                                            ],
                                                            "className": "dbd-kpi-card--compact"
                                                          }
                                                        }
                                                      ]
                                                    },
                                                    {
                                                      "name": "CommonCol",
                                                      "props": {
                                                        "w": 8
                                                      },
                                                      "children": [
                                                        {
                                                          "name": "KpiSummaryCard",
                                                          "props": {
                                                            "titleCn": "月峰值DAU",
                                                            "titleEn": "Monthly Peak DAU",
                                                            "valueMetric": "mtd_max_active_users",
                                                            "formatRule": "thousandsInit",
                                                            "icon": "user-ua",
                                                            "valueDataKey": "mtdProgressData",
                                                            "hiddenTargetModules": [
                                                              "target",
                                                              "extraMetrics",
                                                              "circleChart"
                                                            ],
                                                            "className": "dbd-kpi-card--compact"
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  ]
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  "name": "SegmentScrollChildrenWrapper",
                                  "id": "ua_team",
                                  "children": [
                                    {
                                      "name": "SectionHeadingWithSub",
                                      "className": "margin-b-20",
                                      "props": {
                                        "titleCn": "UA团队",
                                        "titleEn": "UA Team",
                                        "subTitleCn": "数据为AFID口径",
                                        "subTitleEn": "Based on AFID"
                                      }
                                    },
                                    {
                                      "name": "AiAnalysisGuard",
                                      "children": [
                                        {
                                          "name": "MarkDownCard",
                                          "className": "dbd-markdown-card-title-black margin-b-20",
                                          "data": {
                                            "subtitle": ""
                                          },
                                          "props": {
                                            "titleEn": "AI Analysis",
                                            "titleCn": "AI分析总结",
                                            "titleIcon": "ai-color-robot",
                                            "content": "{{data.UA.ai_info}}",
                                            "updateDate": "{{data.UA.date}}",
                                            "subtitleEn": "{{subtitle}}",
                                            "subtitleCn": "{{subtitle}}",
                                            "infoType": "{{data.UA.ai_info_type}}",
                                            "htmlKey": "html",
                                            "linkOpenInNewWindow": true
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "name": "KpiOverviewScopeTabs",
                                      "data": {
                                        "kpiOverviewDataScope": "all"
                                      },
                                      "props": {
                                        "defaultScope": "all",
                                        "allTabLabelEn": "All",
                                        "allTabLabelCn": "全部",
                                        "uaScopeTabLabelEn": "UA-ROI Campaign & UA Media Channel",
                                        "uaScopeTabLabelCn": "UA-ROI Campaign & UA 买量渠道",
                                        "uaScopeTipEn": "Data scope: Campaign type = UA-ROI and Media Channel = UA, subject to filters.",
                                        "uaScopeTipCn": "数据口径：Campaign 类型为 UA-ROI，Media Channel 类型为 UA，受筛选器影响"
                                      },
                                      "children": [
                                        {
                                          "name": "UaTeamMetricsCards",
                                          "props": {
                                            "colCount": 3,
                                            "uaScopeRowLayout": [
                                              2,
                                              3
                                            ],
                                            "cards": [
                                              {
                                                "metricKey": "ug_spend",
                                                "titleCn": "{{metricsInfo.spend.cn}}",
                                                "titleEn": "{{metricsInfo.spend.en}}",
                                                "formatRule": "{{metricsInfo.spend.formatter}}",
                                                "tipsEn": "{{metricsInfo.spend.explainEn}}",
                                                "tipsCn": "{{metricsInfo.spend.explainCn}}",
                                                "icon": "money",
                                                "preUnit": "$",
                                                "showFilterSelectedDate": true
                                              },
                                              {
                                                "metricKey": "ug_spend",
                                                "titleCn": "{{metricsInfo.roi_spend.cn}}",
                                                "titleEn": "{{metricsInfo.roi_spend.en}}",
                                                "formatRule": "{{metricsInfo.roi_spend.formatter}}",
                                                "tipsEn": "{{metricsInfo.roi_spend.explainEn}}",
                                                "tipsCn": "{{metricsInfo.roi_spend.explainCn}}",
                                                "icon": "money",
                                                "preUnit": "$",
                                                "showFilterSelectedDate": true,
                                                "filterOverrides": [
                                                  {
                                                    "filterKey": "campaign",
                                                    "selectorKey": "campaign",
                                                    "matchType": "UA-ROI"
                                                  },
                                                  {
                                                    "filterKey": "ua_network",
                                                    "selectorKey": "ua_network",
                                                    "matchTypeNot": [
                                                      "Organic",
                                                      "Pre-Install"
                                                    ]
                                                  }
                                                ],
                                                "omitInUaRoiUaMediaScopeTab": true
                                              },
                                              {
                                                "metricKey": "ug_install",
                                                "titleCn": "{{metricsInfo.ug_install.cn}}",
                                                "titleEn": "{{metricsInfo.ug_install.en}}",
                                                "subtitleCn": "北极星",
                                                "subtitleEn": "北极星",
                                                "formatRule": "{{metricsInfo.ug_install.formatter}}",
                                                "tipsEn": "{{metricsInfo.ug_install.explainEn}}",
                                                "tipsCn": "{{metricsInfo.ug_install.explainCn}}",
                                                "icon": "user-plus",
                                                "className": "dbd-ua-north-star-card",
                                                "showFilterSelectedDate": true
                                              },
                                              {
                                                "metricKey": "af_cpi",
                                                "titleCn": "{{metricsInfo.af_cpi.cn}}",
                                                "titleEn": "{{metricsInfo.af_cpi.en}}",
                                                "formatRule": "{{metricsInfo.af_cpi.formatter}}",
                                                "tipsEn": "{{metricsInfo.af_cpi.explainEn}}",
                                                "tipsCn": "{{metricsInfo.af_cpi.explainCn}}",
                                                "icon": "pie-chart-icon",
                                                "preUnit": "$",
                                                "showFilterSelectedDate": true
                                              },
                                              {
                                                "metricKey": "ua_roas_d1",
                                                "titleCn": "{{metricsInfo.roas1.cn}}",
                                                "titleEn": "{{metricsInfo.roas1.en}}",
                                                "formatRule": "{{metricsInfo.roas1.formatter}}",
                                                "tipsEn": "{{metricsInfo.roas1.explainEn}}",
                                                "tipsCn": "{{metricsInfo.roas1.explainCn}}",
                                                "icon": "game",
                                                "dateShift": 1
                                              },
                                              {
                                                "metricKey": "ua_roas_d7",
                                                "titleCn": "{{metricsInfo.roas7.cn}}",
                                                "titleEn": "{{metricsInfo.roas7.en}}",
                                                "formatRule": "{{metricsInfo.roas7.formatter}}",
                                                "tipsEn": "{{metricsInfo.roas7.explainEn}}",
                                                "tipsCn": "{{metricsInfo.roas7.explainCn}}",
                                                "icon": "game",
                                                "dateShift": 7
                                              }
                                            ],
                                            "uaScopeCards": [
                                              {
                                                "metricKey": "ug_spend",
                                                "titleCn": "Spend",
                                                "titleEn": "Spend",
                                                "formatRule": "{{metricsInfo.spend.formatter}}",
                                                "tipsEn": "{{metricsInfo.spend.explainEn}}",
                                                "tipsCn": "{{metricsInfo.spend.explainCn}}",
                                                "icon": "money",
                                                "preUnit": "$",
                                                "showFilterSelectedDate": true
                                              },
                                              {
                                                "metricKey": "ug_install",
                                                "titleCn": "UA{{metricsInfo.ug_install.cn}}",
                                                "titleEn": "UA {{metricsInfo.ug_install.en}}",
                                                "subtitleCn": "北极星",
                                                "subtitleEn": "北极星",
                                                "formatRule": "{{metricsInfo.ug_install.formatter}}",
                                                "tipsEn": "{{metricsInfo.ug_install.explainEn}}",
                                                "tipsCn": "{{metricsInfo.ug_install.explainCn}}",
                                                "icon": "user-plus",
                                                "className": "dbd-ua-north-star-card",
                                                "showFilterSelectedDate": true
                                              },
                                              {
                                                "metricKey": "af_cpi",
                                                "titleCn": "{{metricsInfo.cpi.cn}}",
                                                "titleEn": "{{metricsInfo.cpi.en}}",
                                                "formatRule": "{{metricsInfo.cpi.formatter}}",
                                                "tipsEn": "{{metricsInfo.cpi.explainEn}}",
                                                "tipsCn": "{{metricsInfo.cpi.explainCn}}",
                                                "icon": "pie-chart-icon",
                                                "preUnit": "$",
                                                "showFilterSelectedDate": true
                                              },
                                              {
                                                "metricKey": "ua_roas_d1",
                                                "titleCn": "{{metricsInfo.roas1.cn}}",
                                                "titleEn": "{{metricsInfo.roas1.en}}",
                                                "formatRule": "{{metricsInfo.roas1.formatter}}",
                                                "tipsEn": "{{metricsInfo.roas1.explainEn}}",
                                                "tipsCn": "{{metricsInfo.roas1.explainCn}}",
                                                "icon": "game",
                                                "dateShift": 1,
                                                "filterOverrides": [
                                                  {
                                                    "filterKey": "campaign",
                                                    "selectorKey": "campaign",
                                                    "matchType": "UA-ROI"
                                                  },
                                                  {
                                                    "filterKey": "ua_network",
                                                    "selectorKey": "ua_network",
                                                    "matchType": "UA"
                                                  }
                                                ]
                                              },
                                              {
                                                "metricKey": "ua_roas_d7",
                                                "titleCn": "{{metricsInfo.roas7.cn}}",
                                                "titleEn": "{{metricsInfo.roas7.en}}",
                                                "formatRule": "{{metricsInfo.roas7.formatter}}",
                                                "tipsEn": "{{metricsInfo.roas7.explainEn}}",
                                                "tipsCn": "{{metricsInfo.roas7.explainCn}}",
                                                "icon": "game",
                                                "dateShift": 7,
                                                "filterOverrides": [
                                                  {
                                                    "filterKey": "campaign",
                                                    "selectorKey": "campaign",
                                                    "matchType": "UA-ROI"
                                                  },
                                                  {
                                                    "filterKey": "ua_network",
                                                    "selectorKey": "ua_network",
                                                    "matchType": "UA"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          "name": "CommonRow",
                                          "className": "margin-b-10 margin-t-10",
                                          "children": [
                                            {
                                              "name": "ScopeAwareCommonCol",
                                              "props": {
                                                "w": 12,
                                                "scopeWMap": {
                                                  "ua_roi_ua_media": 24
                                                }
                                              },
                                              "children": [
                                                {
                                                  "name": "KpiEventMetricTrendService",
                                                  "metrics": [
                                                    "ug_spend"
                                                  ],
                                                  "anomalyMetricKey": "spend",
                                                  "applyKpiUaRoiUaMediaScope": true,
                                                  "children": [
                                                    {
                                                      "name": "EventMetricTrend",
                                                      "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                      "props": {
                                                        "showTableView": true,
                                                        "enableViewportOptimization": true,
                                                        "abnormalHeight": 375,
                                                        "titleEn": "Spend",
                                                        "titleCn": "UA花费",
                                                        "seriesConfig": [
                                                          {
                                                            "metricKey": "ug_spend",
                                                            "cnName": "UA花费(当天)",
                                                            "enName": "Spend(Today)",
                                                            "color": "#5086F3",
                                                            "formatRule": "thousands2Decimal",
                                                            "dateKey": "date"
                                                          },
                                                          {
                                                            "metricKey": "ug_spend_last_value",
                                                            "cnName": "UA花费(上周同期)",
                                                            "enName": "Spend(Same Day Last Week)",
                                                            "tooltipEnName": "Spend(SDLW)",
                                                            "color": "#69D19C",
                                                            "formatRule": "thousands2Decimal",
                                                            "dateKey": "date",
                                                            "label": {
                                                              "show": false
                                                            },
                                                            "lineStyle": {
                                                              "type": "dotted"
                                                            }
                                                          }
                                                        ],
                                                        "chartConfig": {
                                                          "yAxisFormat": "bmk",
                                                          "formatRule": "thousands2Decimal",
                                                          "dateFormatRule": "MM-DD",
                                                          // anomalyMetricKey: 'spend',
                                                          // kpiEventUi: true,
                                                          "eventTypeDisplayOrder": [
                                                            "版更",
                                                            "UA",
                                                            "玩法",
                                                            "商业化",
                                                            "实验"
                                                          ],
                                                          "eventBubbleDetailsNav": {
                                                            "minCountExclusive": 0,
                                                            "path": "eventAnalysis/eventDetails",
                                                            "query": {
                                                              "timeType": "Day",
                                                              "dashboardType": "overview"
                                                            }
                                                          },
                                                          "eventBubbleItemUnderline": false,
                                                          "eventTypeBarColorMap": {
                                                            版更: {
                                                              tagStyleAliases: ['Version'],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(241, 158, 85, 0.12)',
                                                                fontColor:
                                                                  '#F19E55',
                                                              },
                                                              eventTooltips:
                                                                '#F19E55',
                                                            },
                                                            UA: {
                                                              tagStyleAliases: ['UA'],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(94, 200, 241, 0.12)',
                                                                fontColor:
                                                                  '#5EC8F1',
                                                              },
                                                              eventTooltips:
                                                                '#5EC8F1',
                                                            },
                                                            玩法: {
                                                              tagStyleAliases: ['Gameplay'],
                                                              xAxisBubble: {
                                                                background:
                                                                  '#DBF3E0',
                                                                fontColor:
                                                                  '#1DB440',
                                                              },
                                                              eventTooltips:
                                                                '#1DB440',
                                                            },
                                                            商业化: {
                                                              tagStyleAliases: [
                                                                'Commercialization',
                                                                'Commercial',
                                                              ],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(127, 111, 241, 0.12)',
                                                                fontColor:
                                                          '#7F6FF1',
                                                              },
                                                              eventTooltips:
                                                                '#7F6FF1',
                                                            },
                                                            实验: {
                                                              tagStyleAliases: [
                                                                'Experiment',
                                                                'A/B Test',
                                                                'AB Test',
                                                                'ABTest',
                                                              ],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(110, 119, 148, 0.12)',
                                                                fontColor:
                                                                  '#6E7794',
                                                              },
                                                              eventTooltips:
                                                                '#6E7794',
                                                            },
                                                          },
                                                          "showLegendDimensionIcons": true,
                                                          "showYAxisLine": false
                                                        },
                                                        "downloadConfig": {
                                                          "columns": [
                                                            {
                                                              "code": "date",
                                                              "name": "日期",
                                                              "nameEn": "Date",
                                                              "nameCn": "日期",
                                                              "format": "yyyy-mm-dd",
                                                              "type": "date"
                                                            },
                                                            {
                                                              "code": "ug_spend",
                                                              "name": "Spend(当天)",
                                                              "nameEn": "Spend(Today)",
                                                              "nameCn": "UA花费(当天)",
                                                              "format": "#,##0.00"
                                                            },
                                                            {
                                                              "code": "ug_spend_last_value",
                                                              "name": "Spend(上周同期)",
                                                              "nameEn": "Spend(Same Day Last Week)",
                                                              "nameCn": "UA花费(上周同期)",
                                                              "format": "#,##0.00"
                                                            },
                                                            {
                                                              "code": "event",
                                                              "dependKey": "date",
                                                              "dateKey": "start_time",
                                                              "name": "当天开始事件名称",
                                                              "nameEn": "Start Event Name (Today)",
                                                              "nameCn": "当天开始事件名称",
                                                              "format": "@",
                                                              "type": "event",
                                                              "wrapText": true
                                                            },
                                                            {
                                                              "code": "last_week_date",
                                                              "name": "上周同期日期",
                                                              "nameEn": "Date (same day last week)",
                                                              "nameCn": "上周同期日期",
                                                              "format": "yyyy-mm-dd",
                                                              "type": "date"
                                                            },
                                                            {
                                                              "code": "last_week_version_event",
                                                              "dependKey": "last_week_date",
                                                              "dateKey": "start_time",
                                                              "name": "上周同期开始事件名称",
                                                              "nameEn": "Start Event Name (Same Day Same Day Last Week)",
                                                              "nameCn": "上周同期开始事件名称",
                                                              "format": "@",
                                                              "type": "event",
                                                              "wrapText": true
                                                            }
                                                          ]
                                                        },
                                                        "yAxisMin": {
                                                          "enabled": false,
                                                          "minRatio": 0
                                                        }
                                                      }
                                                    }
                                                  ]
                                                }
                                              ]
                                            },
                                            {
                                              "name": "CommonCol",
                                              "props": {
                                                "w": 12
                                              },
                                              "children": [
                                                {
                                                  "name": "KpiEventDimensionTrendService",
                                                  "metrics": [
                                                    "ug_spend"
                                                  ],
                                                  "anomalyMetricKey": "ua_roi_spend",
                                                  "valueFormatRule": "thousands2Decimal",
                                                  "campaignMatchType": "UA-ROI",
                                                  "uaNetworkMatchTypeNot": [
                                                    "Organic",
                                                    "Pre-Install"
                                                  ],
                                                  "hideWhenKpiOverviewScope": "ua_roi_ua_media",
                                                  "downloadIncludeLastWeek": false,
                                                  "children": [
                                                    {
                                                      "name": "EventMetricTrend",
                                                      "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                      "props": {
                                                        "showTableView": true,
                                                        "enableViewportOptimization": true,
                                                        "abnormalHeight": 360,
                                                        "titleEn": "UA-ROI Spend",
                                                        "titleCn": "UA-ROI 花费",
                                                        "chartConfig": {
                                                          "yAxisFormat": "bmk",
                                                          "formatRule": "thousands2Decimal",
                                                          "dateFormatRule": "MM-DD",
                                                          "showDataLabel": true,
                                                          // kpiEventUi: true,
                                                          "eventTypeDisplayOrder": [
                                                            "版更",
                                                            "UA",
                                                            "玩法",
                                                            "商业化",
                                                            "实验"
                                                          ],
                                                          "eventBubbleDetailsNav": {
                                                            "minCountExclusive": 0,
                                                            "path": "eventAnalysis/eventDetails",
                                                            "query": {
                                                              "timeType": "Day",
                                                              "dashboardType": "overview"
                                                            }
                                                          },
                                                          "eventBubbleItemUnderline": false,
                                                          "eventTypeBarColorMap": {
                                                            版更: {
                                                              tagStyleAliases: ['Version'],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(241, 158, 85, 0.12)',
                                                                fontColor:
                                                                  '#F19E55',
                                                              },
                                                              eventTooltips:
                                                                '#F19E55',
                                                            },
                                                            UA: {
                                                              tagStyleAliases: ['UA'],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(94, 200, 241, 0.12)',
                                                                fontColor:
                                                                  '#5EC8F1',
                                                              },
                                                              eventTooltips:
                                                                '#5EC8F1',
                                                            },
                                                            玩法: {
                                                              tagStyleAliases: ['Gameplay'],
                                                              xAxisBubble: {
                                                                background:
                                                                  '#DBF3E0',
                                                                fontColor:
                                                                  '#1DB440',
                                                              },
                                                              eventTooltips:
                                                                '#1DB440',
                                                            },
                                                            商业化: {
                                                              tagStyleAliases: [
                                                                'Commercialization',
                                                                'Commercial',
                                                              ],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(127, 111, 241, 0.12)',
                                                                fontColor:
                                                                  '#7F6FF1',
                                                              },
                                                              eventTooltips:
                                                                '#7F6FF1',
                                                            },
                                                            实验: {
                                                              tagStyleAliases: [
                                                                'Experiment',
                                                                'A/B Test',
                                                                'AB Test',
                                                                'ABTest',
                                                              ],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(110, 119, 148, 0.12)',
                                                                fontColor:
                                                                  '#6E7794',
                                                              },
                                                              eventTooltips:
                                                                '#6E7794',
                                                            },
                                                          },
                                                          "showLegendDimensionIcons": true,
                                                          "showYAxisLine": false,
                                                          "legendIconSource": "ua_network"
                                                        },
                                                        "downloadConfig": {},
                                                        "yAxisMin": {
                                                          "enabled": false,
                                                          "minRatio": 0
                                                        }
                                                      }
                                                    }
                                                  ]
                                                }
                                              ]
                                            }
                                          ]
                                        },
                                        {
                                          "name": "CommonRow",
                                          "className": "margin-b-10",
                                          "children": [
                                            {
                                              "name": "CommonCol",
                                              "props": {
                                                "w": 12
                                              },
                                              "children": [
                                                {
                                                  "name": "KpiEventMetricTrendService",
                                                  "metrics": [
                                                    "ug_install"
                                                  ],
                                                  "anomalyMetricKey": "ua_new_install",
                                                  "applyKpiUaRoiUaMediaScope": true,
                                                  "children": [
                                                    {
                                                      "name": "EventMetricTrend",
                                                      "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                      "props": {
                                                        "showTableView": true,
                                                        "enableViewportOptimization": true,
                                                        "titleEn": "New",
                                                        "titleCn": "新进",
                                                        "seriesConfig": [
                                                          {
                                                            "metricKey": "ug_install",
                                                            "cnName": "新进(当天)",
                                                            "enName": "New(Today)",
                                                            "color": "#5086F3",
                                                            "formatRule": "thousandsInit",
                                                            "dateKey": "date"
                                                          },
                                                          {
                                                            "metricKey": "ug_install_last_value",
                                                            "cnName": "新进(上周同期)",
                                                            "enName": "New(Same Day Last Week)",
                                                            "tooltipEnName": "New(SDLW)",
                                                            "color": "#69D19C",
                                                            "formatRule": "thousandsInit",
                                                            "dateKey": "date",
                                                            "label": {
                                                              "show": false
                                                            },
                                                            "lineStyle": {
                                                              "type": "dotted"
                                                            }
                                                          }
                                                        ],
                                                        "chartConfig": {
                                                          "yAxisFormat": "bmk",
                                                          "formatRule": "thousandsInit",
                                                          "dateFormatRule": "MM-DD",
                                                          // kpiEventUi: true,
                                                          "eventTypeDisplayOrder": [
                                                            "版更",
                                                            "UA",
                                                            "玩法",
                                                            "商业化",
                                                            "实验"
                                                          ],
                                                          "eventBubbleDetailsNav": {
                                                            "minCountExclusive": 0,
                                                            "path": "eventAnalysis/eventDetails",
                                                            "query": {
                                                              "timeType": "Day",
                                                              "dashboardType": "overview"
                                                            }
                                                          },
                                                          "eventBubbleItemUnderline": false,
                                                          "eventTypeBarColorMap": {
                                                            版更: {
                                                              tagStyleAliases: ['Version'],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(241, 158, 85, 0.12)',
                                                                fontColor:
                                                                  '#F19E55',
                                                              },
                                                              eventTooltips:
                                                                '#F19E55',
                                                            },
                                                            UA: {
                                                              tagStyleAliases: ['UA'],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(94, 200, 241, 0.12)',
                                                                fontColor:
                                                                  '#5EC8F1',
                                                              },
                                                              eventTooltips:
                                                                '#5EC8F1',
                                                            },
                                                            玩法: {
                                                              tagStyleAliases: ['Gameplay'],
                                                              xAxisBubble: {
                                                                background:
                                                                  '#DBF3E0',
                                                                fontColor:
                                                                  '#1DB440',
                                                              },
                                                              eventTooltips:
                                                                '#1DB440',
                                                            },
                                                            商业化: {
                                                              tagStyleAliases: [
                                                                'Commercialization',
                                                                'Commercial',
                                                              ],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(127, 111, 241, 0.12)',
                                                                fontColor:
                                                                  '#7F6FF1',
                                                              },
                                                              eventTooltips:
                                                                '#7F6FF1',
                                                            },
                                                            实验: {
                                                              tagStyleAliases: [
                                                                'Experiment',
                                                                'A/B Test',
                                                                'AB Test',
                                                                'ABTest',
                                                              ],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(110, 119, 148, 0.12)',
                                                                fontColor:
                                                                  '#6E7794',
                                                              },
                                                              eventTooltips:
                                                                '#6E7794',
                                                            },
                                                          },
                                                          "showLegendDimensionIcons": true,
                                                          "showYAxisLine": false
                                                        },
                                                        "downloadConfig": {
                                                          "columns": [
                                                            {
                                                              "code": "date",
                                                              "name": "日期",
                                                              "nameEn": "Date",
                                                              "nameCn": "日期",
                                                              "format": "yyyy-mm-dd",
                                                              "type": "date"
                                                            },
                                                            {
                                                              "code": "ug_install",
                                                              "name": "新进(当天)",
                                                              "nameEn": "New(Today)",
                                                              "nameCn": "新进(当天)",
                                                              "format": "#,##0"
                                                            },
                                                            {
                                                              "code": "ug_install_last_value",
                                                              "name": "新进(上周同期)",
                                                              "nameEn": "New(Same Day Last Week)",
                                                              "nameCn": "新进(上周同期)",
                                                              "format": "#,##0"
                                                            },
                                                            {
                                                              "code": "event",
                                                              "dependKey": "date",
                                                              "dateKey": "start_time",
                                                              "name": "当天开始事件名称",
                                                              "nameEn": "Start Event Name (Today)",
                                                              "nameCn": "当天开始事件名称",
                                                              "format": "@",
                                                              "type": "event",
                                                              "wrapText": true
                                                            },
                                                            {
                                                              "code": "last_week_date",
                                                              "name": "上周同期日期",
                                                              "nameEn": "Date (same day last week)",
                                                              "nameCn": "上周同期日期",
                                                              "format": "yyyy-mm-dd",
                                                              "type": "date"
                                                            }
                                                          ]
                                                        },
                                                        "yAxisMin": {
                                                          "enabled": false,
                                                          "minRatio": 0
                                                        }
                                                      }
                                                    }
                                                  ]
                                                }
                                              ]
                                            },
                                            {
                                              "name": "CommonCol",
                                              "props": {
                                                "w": 12
                                              },
                                              "children": [
                                                {
                                                  "name": "KpiEventMetricTrendService",
                                                  "metrics": [
                                                    "af_cpi"
                                                  ],
                                                  "anomalyMetricKey": "cpi",
                                                  "applyKpiUaRoiUaMediaScope": true,
                                                  "children": [
                                                    {
                                                      "name": "EventMetricTrend",
                                                      "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                      "props": {
                                                        "showTableView": true,
                                                        "enableViewportOptimization": true,
                                                        "titleEn": "Af-CPI",
                                                        "titleCn": "Af-CPI",
                                                        "seriesConfig": [
                                                          {
                                                            "metricKey": "af_cpi",
                                                            "cnName": "Af-CPI(当天)",
                                                            "enName": "Af-CPI(Today)",
                                                            "color": "#5086F3",
                                                            "formatRule": "thousands2Decimal",
                                                            "dateKey": "date"
                                                          },
                                                          {
                                                            "metricKey": "af_cpi_last_value",
                                                            "cnName": "Af-CPI(上周同期)",
                                                            "enName": "Af-CPI(Same Day Last Week)",
                                                            "tooltipEnName": "Af-CPI(SDLW)",
                                                            "color": "#69D19C",
                                                            "formatRule": "thousands2Decimal",
                                                            "dateKey": "date",
                                                            "label": {
                                                              "show": false
                                                            },
                                                            "lineStyle": {
                                                              "type": "dotted"
                                                            }
                                                          }
                                                        ],
                                                        "chartConfig": {
                                                          "yAxisFormat": "bmk00",
                                                          "formatRule": "thousands2Decimal",
                                                          "dateFormatRule": "MM-DD",
                                                          // kpiEventUi: true,
                                                          "eventTypeDisplayOrder": [
                                                            "版更",
                                                            "UA",
                                                            "玩法",
                                                            "商业化",
                                                            "实验"
                                                          ],
                                                          "eventBubbleDetailsNav": {
                                                            "minCountExclusive": 0,
                                                            "path": "eventAnalysis/eventDetails",
                                                            "query": {
                                                              "timeType": "Day",
                                                              "dashboardType": "overview"
                                                            }
                                                          },
                                                          "eventBubbleItemUnderline": false,
                                                          "eventTypeBarColorMap": {
                                                            版更: {
                                                              tagStyleAliases: ['Version'],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(241, 158, 85, 0.12)',
                                                                fontColor:
                                                                  '#F19E55',
                                                              },
                                                              eventTooltips:
                                                                '#F19E55',
                                                            },
                                                            UA: {
                                                              tagStyleAliases: ['UA'],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(94, 200, 241, 0.12)',
                                                                fontColor:
                                                                  '#5EC8F1',
                                                              },
                                                              eventTooltips:
                                                                '#5EC8F1',
                                                            },
                                                            玩法: {
                                                              tagStyleAliases: ['Gameplay'],
                                                              xAxisBubble: {
                                                                background:
                                                                  '#DBF3E0',
                                                                fontColor:
                                                                  '#1DB440',
                                                              },
                                                              eventTooltips:
                                                                '#1DB440',
                                                            },
                                                            商业化: {
                                                              tagStyleAliases: [
                                                                'Commercialization',
                                                                'Commercial',
                                                              ],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(127, 111, 241, 0.12)',
                                                                fontColor:
                                                          '#7F6FF1',
                                                              },
                                                              eventTooltips:
                                                                '#7F6FF1',
                                                            },
                                                            实验: {
                                                              tagStyleAliases: [
                                                                'Experiment',
                                                                'A/B Test',
                                                                'AB Test',
                                                                'ABTest',
                                                              ],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(110, 119, 148, 0.12)',
                                                                fontColor:
                                                                  '#6E7794',
                                                              },
                                                              eventTooltips:
                                                                '#6E7794',
                                                            },
                                                          },
                                                          "showLegendDimensionIcons": true,
                                                          "showYAxisLine": false
                                                        },
                                                        "downloadConfig": {
                                                          "columns": [
                                                            {
                                                              "code": "date",
                                                              "name": "日期",
                                                              "nameEn": "Date",
                                                              "nameCn": "日期",
                                                              "format": "yyyy-mm-dd",
                                                              "type": "date"
                                                            },
                                                            {
                                                              "code": "af_cpi",
                                                              "name": "Af-CPI(当天)",
                                                              "nameEn": "Af-CPI(Today)",
                                                              "nameCn": "CPI(当天)",
                                                              "format": "#,##0.00"
                                                            },
                                                            {
                                                              "code": "af_cpi_last_value",
                                                              "name": "Af-CPI(上周同期)",
                                                              "nameEn": "Af-CPI(Same Day Last Week)",
                                                              "nameCn": "Af-CPI(上周同期)",
                                                              "format": "#,##0.00"
                                                            },
                                                            {
                                                              "code": "event",
                                                              "dependKey": "date",
                                                              "dateKey": "start_time",
                                                              "name": "当天开始事件名称",
                                                              "nameEn": "Start Event Name (Today)",
                                                              "nameCn": "当天开始事件名称",
                                                              "format": "@",
                                                              "type": "event",
                                                              "wrapText": true
                                                            },
                                                            {
                                                              "code": "last_week_date",
                                                              "name": "上周同期日期",
                                                              "nameEn": "Date (same day last week)",
                                                              "nameCn": "上周同期日期",
                                                              "format": "yyyy-mm-dd",
                                                              "type": "date"
                                                            },
                                                            {
                                                              "code": "last_week_version_event",
                                                              "dependKey": "last_week_date",
                                                              "dateKey": "start_time",
                                                              "name": "上周同期开始事件名称",
                                                              "nameEn": "Start Event Name (Same Day Same Day Last Week)",
                                                              "nameCn": "上周同期开始事件名称",
                                                              "format": "@",
                                                              "type": "event",
                                                              "wrapText": true
                                                            }
                                                          ]
                                                        },
                                                        "yAxisMin": {
                                                          "enabled": false,
                                                          "minRatio": 0
                                                        }
                                                      }
                                                    }
                                                  ]
                                                }
                                              ]
                                            }
                                          ]
                                        },
                                        {
                                          "name": "CommonRow",
                                          "children": [
                                            {
                                              "name": "CommonCol",
                                              "props": {
                                                "w": 24
                                              },
                                              "children": [
                                                {
                                                  "name": "KpiOverviewEventDataBridge",
                                                  "className": "",
                                                  "type": "view",
                                                  "children": [
                                                    {
                                                      "name": "KpiEventMetricTrendService",
                                                      "metrics": [
                                                        "ua_roas_d1",
                                                        "ua_roas_d7",
                                                        "ua_roas_d14",
                                                        "ua_roas_d30"
                                                      ],
                                                      "minTrendRangeDays": 30,
                                                      "anomalyMetricKey": "roas",
                                                      "applyKpiUaRoiUaMediaScope": true,
                                                      "children": [
                                                        {
                                                          "name": "EventMetricTrend",
                                                          "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                          "props": {
                                                            "showTableView": true,
                                                            "enableViewportOptimization": true,
                                                            "titleEn": "ROAS (D1/D7/D14/D30)",
                                                            "titleCn": "ROAS (D1/D7/D14/D30)",
                                                            "seriesConfig": [
                                                              {
                                                                "metricKey": "ua_roas_d1",
                                                                "cnName": "ROAS1",
                                                                "enName": "ROAS1",
                                                                "formatRule": "percent2Decimal",
                                                                "dateKey": "date",
                                                                "anomalySubKey": "d1_roas"
                                                              },
                                                              {
                                                                "metricKey": "ua_roas_d7",
                                                                "cnName": "ROAS7",
                                                                "enName": "ROAS7",
                                                                "formatRule": "percent2Decimal",
                                                                "dateKey": "date",
                                                                "anomalySubKey": "d7_roas",
                                                                "label": {
                                                                  "show": false
                                                                }
                                                              },
                                                              {
                                                                "metricKey": "ua_roas_d14",
                                                                "cnName": "ROAS14",
                                                                "enName": "ROAS14",
                                                                "formatRule": "percent2Decimal",
                                                                "dateKey": "date",
                                                                "anomalySubKey": "d14_roas",
                                                                "label": {
                                                                  "show": false
                                                                }
                                                              },
                                                              {
                                                                "metricKey": "ua_roas_d30",
                                                                "cnName": "ROAS30",
                                                                "enName": "ROAS30",
                                                                "formatRule": "percent2Decimal",
                                                                "dateKey": "date",
                                                                "anomalySubKey": "d30_roas",
                                                                "label": {
                                                                  "show": false
                                                                }
                                                              }
                                                            ],
                                                            "chartConfig": {
                                                              "yAxisFormat": "percentInt",
                                                              "formatRule": "percent2Decimal",
                                                              "dateFormatRule": "MM-DD",
                                                              // kpiEventUi: true,
                                                              "tooltipThrottleMs": 48,
                                                              "eventTypeDisplayOrder": [
                                                                "版更",
                                                                "UA",
                                                                "玩法",
                                                                "商业化",
                                                                "实验"
                                                              ],
                                                              "eventBubbleDetailsNav": {
                                                                "minCountExclusive": 0,
                                                                "path": "eventAnalysis/eventDetails",
                                                                "query": {
                                                                  "timeType": "Day",
                                                                  "dashboardType": "overview"
                                                                }
                                                              },
                                                              "eventBubbleItemUnderline": false,
                                                              "eventTypeBarColorMap": {
                                                                版更: {
                                                                  tagStyleAliases: ['Version'],
                                                                  xAxisBubble: {
                                                                    background:
                                                              'rgba(241, 158, 85, 0.12)',
                                                                    fontColor:
                                                              '#F19E55',
                                                                  },
                                                                  eventTooltips:
                                                            '#F19E55',
                                                                },
                                                                UA: {
                                                                  tagStyleAliases: ['UA'],
                                                                  xAxisBubble: {
                                                                    background:
                                                              'rgba(94, 200, 241, 0.12)',
                                                                    fontColor:
                                                              '#5EC8F1',
                                                                  },
                                                                  eventTooltips:
                                                            '#5EC8F1',
                                                                },
                                                                玩法: {
                                                                  tagStyleAliases: ['Gameplay'],
                                                                  xAxisBubble: {
                                                                    background:
                                                              '#DBF3E0',
                                                                    fontColor:
                                                              '#1DB440',
                                                                  },
                                                                  eventTooltips:
                                                            '#1DB440',
                                                                },
                                                                商业化: {
                                                                  tagStyleAliases: [
                                                                    'Commercialization',
                                                                    'Commercial',
                                                                  ],
                                                                  xAxisBubble: {
                                                                    background:
                                                              'rgba(127, 111, 241, 0.12)',
                                                                    fontColor:
                                                              '#7F6FF1',
                                                                  },
                                                                  eventTooltips:
                                                            '#7F6FF1',
                                                                },
                                                                实验: {
                                                                  tagStyleAliases: [
                                                                    'Experiment',
                                                                    'A/B Test',
                                                                    'AB Test',
                                                                    'ABTest',
                                                                  ],
                                                                  xAxisBubble: {
                                                                    background:
                                                              'rgba(110, 119, 148, 0.12)',
                                                                    fontColor:
                                                              '#6E7794',
                                                                  },
                                                                  eventTooltips:
                                                            '#6E7794',
                                                                },
                                                              },
                                                              "showLegendDimensionIcons": true,
                                                              "showYAxisLine": false
                                                            },
                                                            "downloadConfig": {
                                                              "columns": [
                                                                {
                                                                  "code": "date",
                                                                  "name": "日期",
                                                                  "nameEn": "Date",
                                                                  "nameCn": "日期",
                                                                  "format": "yyyy-mm-dd",
                                                                  "type": "date"
                                                                },
                                                                {
                                                                  "code": "ua_roas_d1",
                                                                  "name": "ROAS1",
                                                                  "nameEn": "ROAS1",
                                                                  "nameCn": "ROAS1",
                                                                  "format": "0.00%"
                                                                },
                                                                {
                                                                  "code": "ua_roas_d7",
                                                                  "name": "ROAS7",
                                                                  "nameEn": "ROAS7",
                                                                  "nameCn": "ROAS7",
                                                                  "format": "0.00%"
                                                                },
                                                                {
                                                                  "code": "ua_roas_d14",
                                                                  "name": "ROAS14",
                                                                  "nameEn": "ROAS14",
                                                                  "nameCn": "ROAS14",
                                                                  "format": "0.00%"
                                                                },
                                                                {
                                                                  "code": "ua_roas_d30",
                                                                  "name": "ROAS30",
                                                                  "nameEn": "ROAS30",
                                                                  "nameCn": "ROAS30",
                                                                  "format": "0.00%"
                                                                },
                                                                {
                                                                  "code": "event",
                                                                  "dependKey": "date",
                                                                  "dateKey": "start_time",
                                                                  "name": "当天开始事件名称",
                                                                  "nameEn": "Start Event Name (Today)",
                                                                  "nameCn": "当天开始事件名称",
                                                                  "format": "@",
                                                                  "type": "event",
                                                                  "wrapText": true
                                                                }
                                                              ]
                                                            },
                                                            "yAxisMin": {
                                                              "enabled": false,
                                                              "minRatio": 0
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  ]
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  "name": "SegmentScrollChildrenWrapper",
                                  "id": "dev_team",
                                  "children": [
                                    {
                                      "name": "SectionHeadingWithSub",
                                      "props": {
                                        "titleCn": "产研团队",
                                        "titleEn": "R&D Team",
                                        "subTitleCn": "数据为XWID口径",
                                        "subTitleEn": "Based on XWID"
                                      }
                                    },
                                    {
                                      "name": "AiAnalysisGuard",
                                      "children": [
                                        {
                                          "name": "MarkDownCard",
                                          "className": "margin-t-20 dbd-markdown-card-title-black margin-b-20",
                                          "data": {
                                            "subtitle": ""
                                          },
                                          "props": {
                                            "titleEn": "AI Analysis",
                                            "titleCn": "AI分析总结",
                                            "titleIcon": "ai-color-robot",
                                            "content": "{{data.RD.ai_info}}",
                                            "updateDate": "{{data.RD.date}}",
                                            "subtitleEn": "{{subtitle}}",
                                            "subtitleCn": "{{subtitle}}",
                                            "infoType": "{{data.RD.ai_info_type}}",
                                            "htmlKey": "html",
                                            "linkOpenInNewWindow": true
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "name": "UaTeamMetricsCards",
                                      "props": {
                                        "colCount": 2,
                                        "cards": [
                                          {
                                            "metricKey": "active_users",
                                            "titleCn": "{{metricsInfo.active_users_dau.cn}}",
                                            "titleEn": "{{metricsInfo.active_users_dau.en}}",
                                            "formatRule": "{{metricsInfo.active_users_dau.formatter}}",
                                            "tipsEn": "{{metricsInfo.active_users_dau.explainEn}}",
                                            "tipsCn": "{{metricsInfo.active_users_dau.explainCn}}",
                                            "icon": "user-u",
                                            "showFilterSelectedDate": true
                                          },
                                          {
                                            "metricKey": "d7t6",
                                            "titleCn": "{{metricsInfo.d7.cn}}",
                                            "titleEn": "{{metricsInfo.d7.en}}",
                                            "formatRule": "{{metricsInfo.d7t6.formatter}}",
                                            "tipsEn": "{{metricsInfo.d7t6.explainEn}}",
                                            "tipsCn": "{{metricsInfo.d7t6.explainCn}}",
                                            "icon": "game",
                                            "showDateLabel": true,
                                            "dateLabelShift": 6
                                          }
                                        ]
                                      }
                                    },
                                    {
                                      "name": "CommonRow",
                                      "className": "margin-b-10 margin-t-10",
                                      "children": [
                                        {
                                          "name": "CommonCol",
                                          "props": {
                                            "w": 12
                                          },
                                          "children": [
                                            {
                                              "name": "KpiEventDimensionTrendService",
                                              "metrics": [
                                                "active_users"
                                              ],
                                              "anomalyMetricKey": "dau",
                                              "valueFormatRule": "thousandsInit",
                                              "dimensionValueSource": "row_field",
                                              "dimensionKey": "system",
                                              "selectorMapKey": "system",
                                              "accumulation": {
                                                "by_system": true
                                              },
                                              "allowedOsCodes": [
                                                "1",
                                                "2",
                                                "255"
                                              ],
                                              "dimensionSeriesOrderPriority": [
                                                "1"
                                              ],
                                              "downloadIncludeLastWeek": false,
                                              "children": [
                                                {
                                                  "name": "EventMetricTrend",
                                                  "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                  "props": {
                                                    "showTableView": true,
                                                    "enableViewportOptimization": true,
                                                    "titleEn": "DAU",
                                                    "titleCn": "日活跃",
                                                    "chartConfig": {
                                                      "yAxisFormat": "bmk",
                                                      "formatRule": "thousandsInit",
                                                      "dateFormatRule": "MM-DD",
                                                      // kpiEventUi: true,
                                                      "showDataLabel": true,
                                                      "eventTypeDisplayOrder": [
                                                        "版更",
                                                        "UA",
                                                        "玩法",
                                                        "商业化",
                                                        "实验"
                                                      ],
                                                      "eventBubbleDetailsNav": {
                                                        "minCountExclusive": 0,
                                                        "path": "eventAnalysis/eventDetails",
                                                        "query": {
                                                          "timeType": "Day",
                                                          "dashboardType": "overview"
                                                        }
                                                      },
                                                      "eventBubbleItemUnderline": false,
                                                      "eventTypeBarColorMap": {
                                                        版更: {
                                                          tagStyleAliases: ['Version'],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(241, 158, 85, 0.12)',
                                                            fontColor:
                                                              '#F19E55',
                                                          },
                                                          eventTooltips:
                                                            '#F19E55',
                                                        },
                                                        UA: {
                                                          tagStyleAliases: ['UA'],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(94, 200, 241, 0.12)',
                                                            fontColor:
                                                              '#5EC8F1',
                                                          },
                                                          eventTooltips:
                                                            '#5EC8F1',
                                                        },
                                                        玩法: {
                                                          tagStyleAliases: ['Gameplay'],
                                                          xAxisBubble: {
                                                            background:
                                                              '#DBF3E0',
                                                            fontColor:
                                                              '#1DB440',
                                                          },
                                                          eventTooltips:
                                                            '#1DB440',
                                                        },
                                                        商业化: {
                                                          tagStyleAliases: [
                                                            'Commercialization',
                                                            'Commercial',
                                                          ],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(127, 111, 241, 0.12)',
                                                            fontColor:
                                                              '#7F6FF1',
                                                          },
                                                          eventTooltips:
                                                            '#7F6FF1',
                                                        },
                                                        实验: {
                                                          tagStyleAliases: [
                                                            'Experiment',
                                                            'A/B Test',
                                                            'AB Test',
                                                            'ABTest',
                                                          ],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(110, 119, 148, 0.12)',
                                                            fontColor:
                                                              '#6E7794',
                                                          },
                                                          eventTooltips:
                                                            '#6E7794',
                                                        },
                                                      },
                                                      "showLegendDimensionIcons": true,
                                                      "showYAxisLine": false,
                                                      "legendIconSource": "system"
                                                    },
                                                    "downloadConfig": {},
                                                    "yAxisMin": {
                                                      "enabled": false,
                                                      "minRatio": 0
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          ]
                                        },
                                        {
                                          "name": "CommonCol",
                                          "props": {
                                            "w": 12
                                          },
                                          "children": [
                                            {
                                              "name": "KpiEventDimensionTrendService",
                                              "metrics": [
                                                "d7"
                                              ],
                                              "anomalyMetricKey": "d7",
                                              "valueFormatRule": "percent2Decimal",
                                              "dimensionValueSource": "row_field",
                                              "dimensionKey": "system",
                                              "selectorMapKey": "system",
                                              "accumulation": {
                                                "by_system": true
                                              },
                                              "allowedOsCodes": [
                                                "1",
                                                "2",
                                                "255"
                                              ],
                                              "dimensionSeriesOrderPriority": [
                                                "1"
                                              ],
                                              "downloadIncludeLastWeek": false,
                                              "children": [
                                                {
                                                  "name": "EventMetricTrend",
                                                  "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                  "props": {
                                                    "showTableView": true,
                                                    "enableViewportOptimization": true,
                                                    "titleEn": "D7",
                                                    "titleCn": "7留",
                                                    "chartConfig": {
                                                      "yAxisFormat": "percentInt",
                                                      "formatRule": "percent2Decimal",
                                                      "dateFormatRule": "MM-DD",
                                                      // kpiEventUi: true,
                                                      "showDataLabel": true,
                                                      "eventTypeDisplayOrder": [
                                                        "版更",
                                                        "UA",
                                                        "玩法",
                                                        "商业化",
                                                        "实验"
                                                      ],
                                                      "eventBubbleDetailsNav": {
                                                        "minCountExclusive": 0,
                                                        "path": "eventAnalysis/eventDetails",
                                                        "query": {
                                                          "timeType": "Day",
                                                          "dashboardType": "overview"
                                                        }
                                                      },
                                                      "eventBubbleItemUnderline": false,
                                                      "eventTypeBarColorMap": {
                                                        版更: {
                                                          tagStyleAliases: ['Version'],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(241, 158, 85, 0.12)',
                                                            fontColor:
                                                              '#F19E55',
                                                          },
                                                          eventTooltips:
                                                            '#F19E55',
                                                        },
                                                        UA: {
                                                          tagStyleAliases: ['UA'],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(94, 200, 241, 0.12)',
                                                            fontColor:
                                                              '#5EC8F1',
                                                          },
                                                          eventTooltips:
                                                            '#5EC8F1',
                                                        },
                                                        玩法: {
                                                          tagStyleAliases: ['Gameplay'],
                                                          xAxisBubble: {
                                                            background:
                                                              '#DBF3E0',
                                                            fontColor:
                                                              '#1DB440',
                                                          },
                                                          eventTooltips:
                                                            '#1DB440',
                                                        },
                                                        商业化: {
                                                          tagStyleAliases: [
                                                            'Commercialization',
                                                            'Commercial',
                                                          ],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(127, 111, 241, 0.12)',
                                                            fontColor:
                                                              '#7F6FF1',
                                                          },
                                                          eventTooltips:
                                                            '#7F6FF1',
                                                        },
                                                        实验: {
                                                          tagStyleAliases: [
                                                            'Experiment',
                                                            'A/B Test',
                                                            'AB Test',
                                                            'ABTest',
                                                          ],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(110, 119, 148, 0.12)',
                                                            fontColor:
                                                              '#6E7794',
                                                          },
                                                          eventTooltips:
                                                            '#6E7794',
                                                        },
                                                      },
                                                      "showLegendDimensionIcons": true,
                                                      "showYAxisLine": false,
                                                      "legendIconSource": "system"
                                                    },
                                                    "downloadConfig": {},
                                                    "yAxisMin": {
                                                      "enabled": false,
                                                      "minRatio": 0
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "UaTeamMetricsCards",
                                      "props": {
                                        "colCount": 4,
                                        "style": {
                                          "marginTop": 0,
                                          "marginBottom": 20
                                        },
                                        "cards": [
                                          {
                                            "metricKey": "d7t6",
                                            "titleCn": "Applovin_安卓 D7",
                                            "titleEn": "Applovin_安卓 D7",
                                            "subtitleCn": "北极星",
                                            "subtitleEn": "北极星",
                                            "className": "dbd-ua-north-star-card",
                                            "formatRule": "percent2Decimal",
                                            "dateLabelShift": 6,
                                            "iconImages": [
                                              {
                                                "type": "system",
                                                "value": "android_green"
                                              }
                                            ],
                                            "filterOverrides": [
                                              {
                                                "filterKey": "ua_network",
                                                "selectorKey": "ua_network",
                                                "matchContains": "applovin_adn"
                                              },
                                              {
                                                "filterKey": "system",
                                                "values": [
                                                  "1"
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "metricKey": "d7t6",
                                            "titleCn": "Applovin_安卓_美国 D7",
                                            "titleEn": "Applovin_安卓_US D7",
                                            "subtitleCn": "北极星",
                                            "subtitleEn": "北极星",
                                            "className": "dbd-ua-north-star-card",
                                            "formatRule": "percent2Decimal",
                                            "dateLabelShift": 6,
                                            "iconImages": [
                                              {
                                                "type": "system",
                                                "value": "android_green"
                                              }
                                            ],
                                            "filterOverrides": [
                                              {
                                                "filterKey": "ua_network",
                                                "selectorKey": "ua_network",
                                                "matchContains": "applovin_adn"
                                              },
                                              {
                                                "filterKey": "system",
                                                "values": [
                                                  "1"
                                                ]
                                              },
                                              {
                                                "filterKey": "market",
                                                "values": [
                                                  "us"
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "metricKey": "d7t6",
                                            "titleCn": "Applovin_iOS D7",
                                            "titleEn": "Applovin_iOS D7",
                                            "formatRule": "percent2Decimal",
                                            "dateLabelShift": 6,
                                            "iconImages": [
                                              {
                                                "type": "system",
                                                "value": "ios"
                                              }
                                            ],
                                            "filterOverrides": [
                                              {
                                                "filterKey": "ua_network",
                                                "selectorKey": "ua_network",
                                                "matchContains": "applovin_adn"
                                              },
                                              {
                                                "filterKey": "system",
                                                "values": [
                                                  "2"
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "metricKey": "d7t6",
                                            "titleCn": "Applovin_iOS_美国 D7",
                                            "titleEn": "Applovin_iOS_US D7",
                                            "formatRule": "percent2Decimal",
                                            "dateLabelShift": 6,
                                            "iconImages": [
                                              {
                                                "type": "system",
                                                "value": "ios"
                                              }
                                            ],
                                            "filterOverrides": [
                                              {
                                                "filterKey": "ua_network",
                                                "selectorKey": "ua_network",
                                                "matchContains": "applovin_adn"
                                              },
                                              {
                                                "filterKey": "system",
                                                "values": [
                                                  "2"
                                                ]
                                              },
                                              {
                                                "filterKey": "market",
                                                "values": [
                                                  "us"
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    },
                                    {
                                      "name": "CommonRow",
                                      "children": [
                                        {
                                          "name": "CommonCol",
                                          "props": {
                                            "w": 12
                                          },
                                          "children": [
                                            {
                                              "name": "KpiApplovinRegionTrendService",
                                              "metrics": [
                                                "d7"
                                              ],
                                              "anomalyMetricKey": "applovin_d7",
                                              "metricResponseKey": "d7",
                                              "valueFormatRule": "percent2Decimal",
                                              "dimensionKey": "system",
                                              "selectorMapKey": "system",
                                              "dimensionSecondaryRowField": "country",
                                              "dimensionLegendCompositeKeys": [
                                                "system",
                                                "country"
                                              ],
                                              "multiSort": [
                                                {
                                                  "sort_by": "date",
                                                  "desc": false
                                                }
                                              ],
                                              "accumulation": {
                                                "by_country": false,
                                                "by_system": true
                                              },
                                              "applovinRegionTabConfig": {
                                                "defaultTabValue": "global",
                                                "segmentOptions": [
                                                  {
                                                    "value": "global",
                                                    "textCn": "Global",
                                                    "textEn": "Global",
                                                    "regionMode": "global"
                                                  },
                                                  {
                                                    "value": "us",
                                                    "textCn": "US",
                                                    "textEn": "US",
                                                    "regionMode": "us"
                                                  }
                                                ]
                                              },
                                              "applovinCustomFilterKey": "ua_network",
                                              "allowedUaNetworkCodes": [
                                                "255",
                                                "applovin_adn"
                                              ],
                                              "applovinCodesByRegionMode": {
                                                "global": {
                                                  "allowedOsCodes": [
                                                    "1",
                                                    "2",
                                                    "255"
                                                  ]
                                                },
                                                "us": {
                                                  "allowedOsCodes": [
                                                    "1",
                                                    "2",
                                                    "255"
                                                  ],
                                                  "allowedMarketsListCode": [
                                                    "255",
                                                    "us"
                                                  ]
                                                }
                                              },
                                              "dimensionSeriesOrderPriority": [
                                                "1"
                                              ],
                                              "downloadIncludeLastWeek": false,
                                              "children": [
                                                {
                                                  "name": "EventMetricTrend",
                                                  "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                  "props": {
                                                    "showTableView": true,
                                                    "enableViewportOptimization": true,
                                                    "titleEn": "Applovin D7",
                                                    "titleCn": "Applovin 7留",
                                                    "chartConfig": {
                                                      "yAxisFormat": "percentInt",
                                                      "formatRule": "percent2Decimal",
                                                      "dateFormatRule": "MM-DD",
                                                      // kpiEventUi: true,
                                                      "showDataLabel": true,
                                                      "eventTypeDisplayOrder": [
                                                        "版更",
                                                        "UA",
                                                        "玩法",
                                                        "商业化",
                                                        "实验"
                                                      ],
                                                      "eventBubbleDetailsNav": {
                                                        "minCountExclusive": 0,
                                                        "path": "eventAnalysis/eventDetails",
                                                        "query": {
                                                          "timeType": "Day",
                                                          "dashboardType": "overview"
                                                        }
                                                      },
                                                      "eventBubbleItemUnderline": false,
                                                      "eventTypeBarColorMap": {
                                                        版更: {
                                                          tagStyleAliases: ['Version'],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(241, 158, 85, 0.12)',
                                                            fontColor:
                                                              '#F19E55',
                                                          },
                                                          eventTooltips:
                                                            '#F19E55',
                                                        },
                                                        UA: {
                                                          tagStyleAliases: ['UA'],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(94, 200, 241, 0.12)',
                                                            fontColor:
                                                              '#5EC8F1',
                                                          },
                                                          eventTooltips:
                                                            '#5EC8F1',
                                                        },
                                                        玩法: {
                                                          tagStyleAliases: ['Gameplay'],
                                                          xAxisBubble: {
                                                            background:
                                                              '#DBF3E0',
                                                            fontColor:
                                                              '#1DB440',
                                                          },
                                                          eventTooltips:
                                                            '#1DB440',
                                                        },
                                                        商业化: {
                                                          tagStyleAliases: [
                                                            'Commercialization',
                                                            'Commercial',
                                                          ],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(127, 111, 241, 0.12)',
                                                            fontColor:
                                                              '#7F6FF1',
                                                          },
                                                          eventTooltips:
                                                            '#7F6FF1',
                                                        },
                                                        实验: {
                                                          tagStyleAliases: [
                                                            'Experiment',
                                                            'A/B Test',
                                                            'AB Test',
                                                            'ABTest',
                                                          ],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(110, 119, 148, 0.12)',
                                                            fontColor:
                                                              '#6E7794',
                                                          },
                                                          eventTooltips:
                                                            '#6E7794',
                                                        },
                                                      },
                                                      "showLegendDimensionIcons": true,
                                                      "showYAxisLine": false,
                                                      "legendIconSource": "system",
                                                      "legendIconCompositeKeys": [
                                                        "system",
                                                        "country"
                                                      ]
                                                    },
                                                    "downloadConfig": {},
                                                    "yAxisMin": {
                                                      "enabled": false,
                                                      "minRatio": 0
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          ]
                                        },
                                        {
                                          "name": "CommonCol",
                                          "props": {
                                            "w": 12
                                          },
                                          "children": [
                                            {
                                              "name": "KpiApplovinRegionTrendService",
                                              "metrics": [
                                                "new_users"
                                              ],
                                              "anomalyMetricKey": "applovin_new_install",
                                              "valueFormatRule": "thousandsInit",
                                              "dimensionKey": "system",
                                              "selectorMapKey": "system",
                                              "dimensionSecondaryRowField": "country",
                                              "dimensionLegendCompositeKeys": [
                                                "system",
                                                "country"
                                              ],
                                              "multiSort": [
                                                {
                                                  "sort_by": "date",
                                                  "desc": false
                                                }
                                              ],
                                              "accumulation": {
                                                "by_country": false,
                                                "by_system": true
                                              },
                                              "applovinRegionTabConfig": {
                                                "defaultTabValue": "global",
                                                "segmentOptions": [
                                                  {
                                                    "value": "global",
                                                    "textCn": "Global",
                                                    "textEn": "Global",
                                                    "regionMode": "global"
                                                  },
                                                  {
                                                    "value": "us",
                                                    "textCn": "US",
                                                    "textEn": "US",
                                                    "regionMode": "us"
                                                  }
                                                ]
                                              },
                                              "applovinCustomFilterKey": "ua_network",
                                              "allowedUaNetworkCodes": [
                                                "255",
                                                "applovin_adn"
                                              ],
                                              "applovinCodesByRegionMode": {
                                                "global": {
                                                  "allowedOsCodes": [
                                                    "1",
                                                    "2",
                                                    "255"
                                                  ]
                                                },
                                                "us": {
                                                  "allowedOsCodes": [
                                                    "1",
                                                    "2",
                                                    "255"
                                                  ],
                                                  "allowedMarketsListCode": [
                                                    "255",
                                                    "us"
                                                  ]
                                                }
                                              },
                                              "dimensionSeriesOrderPriority": [
                                                "1"
                                              ],
                                              "downloadIncludeLastWeek": false,
                                              "children": [
                                                {
                                                  "name": "EventMetricTrend",
                                                  "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                  "props": {
                                                    "showTableView": true,
                                                    "enableViewportOptimization": true,
                                                    "titleEn": "Applovin New Users",
                                                    "titleCn": "Applovin新进用户",
                                                    "chartConfig": {
                                                      "yAxisFormat": "bmk",
                                                      "formatRule": "thousandsInit",
                                                      "dateFormatRule": "MM-DD",
                                                      // kpiEventUi: true,
                                                      "showDataLabel": true,
                                                      "eventTypeDisplayOrder": [
                                                        "版更",
                                                        "UA",
                                                        "玩法",
                                                        "商业化",
                                                        "实验"
                                                      ],
                                                      "eventBubbleDetailsNav": {
                                                        "minCountExclusive": 0,
                                                        "path": "eventAnalysis/eventDetails",
                                                        "query": {
                                                          "timeType": "Day",
                                                          "dashboardType": "overview"
                                                        }
                                                      },
                                                      "eventBubbleItemUnderline": false,
                                                      "eventTypeBarColorMap": {
                                                        版更: {
                                                          tagStyleAliases: ['Version'],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(241, 158, 85, 0.12)',
                                                            fontColor:
                                                              '#F19E55',
                                                          },
                                                          eventTooltips:
                                                            '#F19E55',
                                                        },
                                                        UA: {
                                                          tagStyleAliases: ['UA'],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(94, 200, 241, 0.12)',
                                                            fontColor:
                                                              '#5EC8F1',
                                                          },
                                                          eventTooltips:
                                                            '#5EC8F1',
                                                        },
                                                        玩法: {
                                                          tagStyleAliases: ['Gameplay'],
                                                          xAxisBubble: {
                                                            background:
                                                              '#DBF3E0',
                                                            fontColor:
                                                              '#1DB440',
                                                          },
                                                          eventTooltips:
                                                            '#1DB440',
                                                        },
                                                        商业化: {
                                                          tagStyleAliases: [
                                                            'Commercialization',
                                                            'Commercial',
                                                          ],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(127, 111, 241, 0.12)',
                                                            fontColor:
                                                              '#7F6FF1',
                                                          },
                                                          eventTooltips:
                                                            '#7F6FF1',
                                                        },
                                                        实验: {
                                                          tagStyleAliases: [
                                                            'Experiment',
                                                            'A/B Test',
                                                            'AB Test',
                                                            'ABTest',
                                                          ],
                                                          xAxisBubble: {
                                                            background:
                                                              'rgba(110, 119, 148, 0.12)',
                                                            fontColor:
                                                              '#6E7794',
                                                          },
                                                          eventTooltips:
                                                            '#6E7794',
                                                        },
                                                      },
                                                      "showLegendDimensionIcons": true,
                                                      "showYAxisLine": false,
                                                      "legendIconSource": "system",
                                                      "legendIconCompositeKeys": [
                                                        "system",
                                                        "country"
                                                      ]
                                                    },
                                                    "downloadConfig": {},
                                                    "yAxisMin": {
                                                      "enabled": false,
                                                      "minRatio": 0
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  "name": "SegmentScrollChildrenWrapper",
                                  "id": "commercial_team",
                                  "children": [
                                    {
                                      "name": "SectionHeadingWithSub",
                                      "props": {
                                        "titleCn": "商业化团队",
                                        "titleEn": "Monetization Team",
                                        "subTitleCn": "数据为XWID口径",
                                        "subTitleEn": "Based on XWID"
                                      }
                                    },
                                    {
                                      "name": "AiAnalysisGuard",
                                      "children": [
                                        {
                                          "name": "MarkDownCard",
                                          "className": "margin-t-20 dbd-markdown-card-title-black margin-b-20",
                                          "props": {
                                            "titleEn": "AI Analysis",
                                            "titleCn": "AI分析总结",
                                            "titleIcon": "ai-color-robot",
                                            "content": "{{data.monetization.ai_info}}",
                                            "updateDate": "{{data.monetization.date}}",
                                            "subtitleEn": "{{subtitle}}",
                                            "subtitleCn": "{{subtitle}}",
                                            "infoType": "{{data.monetization.ai_info_type}}",
                                            "htmlKey": "html",
                                            "linkOpenInNewWindow": true
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "name": "KpiOverviewScopeTabs",
                                      "data": {
                                        "kpiOverviewDataScope": "all"
                                      },
                                      "props": {
                                        "defaultScope": "all",
                                        "allTabLabelEn": "All",
                                        "allTabLabelCn": "全部",
                                        "uaScopeTabLabelEn": "UA-ROI Campaign & UA Media Channel",
                                        "uaScopeTabLabelCn": "UA-ROI Campaign & UA 买量渠道",
                                        "uaScopeTipEn": "Data scope: Campaign type = UA-ROI and Media Channel = UA, subject to filters.",
                                        "uaScopeTipCn": "数据口径：Campaign 类型为 UA-ROI，Media Channel 类型为 UA，受筛选器影响"
                                      },
                                      "children": [
                                        {
                                          "name": "UaTeamMetricsCards",
                                          "props": {
                                            "colCount": 4,
                                            "cards": [
                                              {
                                                "metricKey": "register_arpu",
                                                "titleCn": "{{metricsInfo.register_arpu.cn}}",
                                                "titleEn": "{{metricsInfo.register_arpu.en}}",
                                                "subtitleCn": "北极星",
                                                "subtitleEn": "北极星",
                                                "formatRule": "{{metricsInfo.register_arpu.formatter}}",
                                                "tipsEn": "{{metricsInfo.register_arpu.explainEn}}",
                                                "tipsCn": "{{metricsInfo.register_arpu.explainCn}}",
                                                "icon": "money",
                                                "preUnit": "$",
                                                "className": "dbd-ua-north-star-card",
                                                "showFilterSelectedDate": true,
                                                "forceIndependentRequest": true
                                              },
                                              {
                                                "metricKey": "register_arpu",
                                                "titleCn": "Android_{{metricsInfo.register_arpu.cn}}",
                                                "titleEn": "Android_{{metricsInfo.register_arpu.en}}",
                                                "formatRule": "{{metricsInfo.register_arpu.formatter}}",
                                                "tipsEn": "{{metricsInfo.register_arpu.explainEn}}",
                                                "tipsCn": "{{metricsInfo.register_arpu.explainCn}}",
                                                "preUnit": "$",
                                                "className": "dbd-ua-north-star-card",
                                                "showFilterSelectedDate": true,
                                                "iconImages": [
                                                  {
                                                    "type": "system",
                                                    "value": "android_green"
                                                  }
                                                ],
                                                "filterOverrides": [
                                                  {
                                                    "filterKey": "system",
                                                    "values": [
                                                      "1"
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "metricKey": "register_arpu",
                                                "titleCn": "iOS_{{metricsInfo.register_arpu.cn}}",
                                                "titleEn": "iOS_{{metricsInfo.register_arpu.en}}",
                                                "formatRule": "{{metricsInfo.register_arpu.formatter}}",
                                                "tipsEn": "{{metricsInfo.register_arpu.explainEn}}",
                                                "tipsCn": "{{metricsInfo.register_arpu.explainCn}}",
                                                "preUnit": "$",
                                                "showFilterSelectedDate": true,
                                                "iconImages": [
                                                  {
                                                    "type": "system",
                                                    "value": "ios"
                                                  }
                                                ],
                                                "filterOverrides": [
                                                  {
                                                    "filterKey": "system",
                                                    "values": [
                                                      "2"
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "metricKey": "7d_ltv",
                                                "titleCn": "{{metricsInfo.7d_ltv.cn}}",
                                                "titleEn": "{{metricsInfo.7d_ltv.en}}",
                                                "subtitleCn": "北极星",
                                                "subtitleEn": "北极星",
                                                "formatRule": "{{metricsInfo.7d_ltv.formatter}}",
                                                "icon": "money",
                                                "preUnit": "$",
                                                "className": "dbd-ua-north-star-card",
                                                "dateShift": 7
                                              }
                                            ],
                                            "uaScopeCards": [
                                              {
                                                "metricKey": "register_arpu",
                                                "titleCn": "{{metricsInfo.register_arpu.cn}}",
                                                "titleEn": "{{metricsInfo.register_arpu.en}}",
                                                "subtitleCn": "北极星",
                                                "subtitleEn": "北极星",
                                                "formatRule": "{{metricsInfo.register_arpu.formatter}}",
                                                "tipsEn": "{{metricsInfo.register_arpu.explainEn}}",
                                                "tipsCn": "{{metricsInfo.register_arpu.explainCn}}",
                                                "icon": "money",
                                                "preUnit": "$",
                                                "className": "dbd-ua-north-star-card",
                                                "showFilterSelectedDate": true,
                                                "filterOverrides": [
                                                  {
                                                    "filterKey": "campaign",
                                                    "selectorKey": "campaign",
                                                    "matchType": "UA-ROI"
                                                  },
                                                  {
                                                    "filterKey": "ua_network",
                                                    "selectorKey": "ua_network",
                                                    "matchType": "UA"
                                                  }
                                                ]
                                              },
                                              {
                                                "metricKey": "register_arpu",
                                                "titleCn": "Android_{{metricsInfo.register_arpu.cn}}",
                                                "titleEn": "Android_{{metricsInfo.register_arpu.en}}",
                                                "formatRule": "{{metricsInfo.register_arpu.formatter}}",
                                                "tipsEn": "{{metricsInfo.register_arpu.explainEn}}",
                                                "tipsCn": "{{metricsInfo.register_arpu.explainCn}}",
                                                "preUnit": "$",
                                                "className": "dbd-ua-north-star-card",
                                                "showFilterSelectedDate": true,
                                                "iconImages": [
                                                  {
                                                    "type": "system",
                                                    "value": "android_green"
                                                  }
                                                ],
                                                "filterOverrides": [
                                                  {
                                                    "filterKey": "campaign",
                                                    "selectorKey": "campaign",
                                                    "matchType": "UA-ROI"
                                                  },
                                                  {
                                                    "filterKey": "ua_network",
                                                    "selectorKey": "ua_network",
                                                    "matchType": "UA"
                                                  },
                                                  {
                                                    "filterKey": "system",
                                                    "values": [
                                                      "1"
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "metricKey": "register_arpu",
                                                "titleCn": "iOS_{{metricsInfo.register_arpu.cn}}",
                                                "titleEn": "iOS_{{metricsInfo.register_arpu.en}}",
                                                "formatRule": "{{metricsInfo.register_arpu.formatter}}",
                                                "tipsEn": "{{metricsInfo.register_arpu.explainEn}}",
                                                "tipsCn": "{{metricsInfo.register_arpu.explainCn}}",
                                                "preUnit": "$",
                                                "showFilterSelectedDate": true,
                                                "iconImages": [
                                                  {
                                                    "type": "system",
                                                    "value": "ios"
                                                  }
                                                ],
                                                "filterOverrides": [
                                                  {
                                                    "filterKey": "campaign",
                                                    "selectorKey": "campaign",
                                                    "matchType": "UA-ROI"
                                                  },
                                                  {
                                                    "filterKey": "ua_network",
                                                    "selectorKey": "ua_network",
                                                    "matchType": "UA"
                                                  },
                                                  {
                                                    "filterKey": "system",
                                                    "values": [
                                                      "2"
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "metricKey": "7d_ltv",
                                                "titleCn": "{{metricsInfo.7d_ltv.cn}}",
                                                "titleEn": "{{metricsInfo.7d_ltv.en}}",
                                                "subtitleCn": "北极星",
                                                "subtitleEn": "北极星",
                                                "formatRule": "{{metricsInfo.7d_ltv.formatter}}",
                                                "icon": "money",
                                                "preUnit": "$",
                                                "className": "dbd-ua-north-star-card",
                                                "dateShift": 7,
                                                "filterOverrides": [
                                                  {
                                                    "filterKey": "campaign",
                                                    "selectorKey": "campaign",
                                                    "matchType": "UA-ROI"
                                                  },
                                                  {
                                                    "filterKey": "ua_network",
                                                    "selectorKey": "ua_network",
                                                    "matchType": "UA"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          "name": "CommonRow",
                                          "className": "margin-t-10",
                                          "children": [
                                            {
                                              "name": "CommonCol",
                                              "props": {
                                                "w": 12
                                              },
                                              "children": [
                                                {
                                                  "name": "KpiEventAllPlatformTabTrendService",
                                                  "allPlatformTabConfig": {
                                                    "defaultTabValue": "all",
                                                    "segmentOptions": [
                                                      {
                                                        "value": "all",
                                                        "textCn": "All",
                                                        "textEn": "All"
                                                      },
                                                      {
                                                        "value": "platform",
                                                        "textCn": "分平台",
                                                        "textEn": "Platform"
                                                      }
                                                    ]
                                                  },
                                                  "children": [
                                                    {
                                                      "name": "KpiEventMetricTrendService",
                                                      "metrics": [
                                                        "register_arpu"
                                                      ],
                                                      "anomalyMetricKey": "register_arpu",
                                                      "applyKpiUaRoiUaMediaScope": true,
                                                      "children": [
                                                        {
                                                          "name": "EventMetricTrend",
                                                          "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                          "props": {
                                                            "showTableView": true,
                                                            "enableViewportOptimization": true,
                                                            "tableViewHeight": 375,
                                                            "titleEn": "New User ARPU($)",
                                                            "titleCn": "新进ARPU($)",
                                                            "seriesConfig": [
                                                              {
                                                                "metricKey": "register_arpu",
                                                                "cnName": "新进ARPU(当天)",
                                                                "enName": "New User ARPU(Today)",
                                                                "color": "#5086F3",
                                                                "formatRule": "thousands2Decimal",
                                                                "dateKey": "date"
                                                              },
                                                              {
                                                                "metricKey": "register_arpu_last_value",
                                                                "cnName": "新进ARPU(上周同期)",
                                                                "enName": "New User ARPU(Same Day Last Week)",
                                                                "tooltipEnName": "New User ARPU(SDLW)",
                                                                "color": "#69D19C",
                                                                "formatRule": "thousands2Decimal",
                                                                "dateKey": "date",
                                                                "label": {
                                                                  "show": false
                                                                },
                                                                "lineStyle": {
                                                                  "type": "dotted"
                                                                }
                                                              }
                                                            ],
                                                            "chartConfig": {
                                                              "yAxisFormat": "thousands2Decimal",
                                                              "formatRule": "thousands2Decimal",
                                                              "dateFormatRule": "MM-DD",
                                                              // kpiEventUi: true,
                                                              "eventTypeDisplayOrder": [
                                                                "版更",
                                                                "UA",
                                                                "玩法",
                                                                "商业化",
                                                                "实验"
                                                              ],
                                                              "eventBubbleDetailsNav": {
                                                                "minCountExclusive": 0,
                                                                "path": "eventAnalysis/eventDetails",
                                                                "query": {
                                                                  "timeType": "Day",
                                                                  "dashboardType": "overview"
                                                                }
                                                              },
                                                              "eventBubbleItemUnderline": false,
                                                              "eventTypeBarColorMap": {
                                                                版更: {
                                                                  tagStyleAliases: ['Version'],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      'rgba(241, 158, 85, 0.12)',
                                                                    fontColor:
                                                                      '#F19E55',
                                                                  },
                                                                  eventTooltips:
                                                                    '#F19E55',
                                                                },
                                                                UA: {
                                                                  tagStyleAliases: ['UA'],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      'rgba(94, 200, 241, 0.12)',
                                                                    fontColor:
                                                                      '#5EC8F1',
                                                                  },
                                                                  eventTooltips:
                                                                    '#5EC8F1',
                                                                },
                                                                玩法: {
                                                                  tagStyleAliases: ['Gameplay'],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      '#DBF3E0',
                                                                    fontColor:
                                                                      '#1DB440',
                                                                  },
                                                                  eventTooltips:
                                                                    '#1DB440',
                                                                },
                                                                商业化: {
                                                                  tagStyleAliases: [
                                                                    'Commercialization',
                                                                    'Commercial',
                                                                  ],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      'rgba(127, 111, 241, 0.12)',
                                                                    fontColor:
                                                                      '#7F6FF1',
                                                                  },
                                                                  eventTooltips:
                                                                    '#7F6FF1',
                                                                },
                                                                实验: {
                                                                  tagStyleAliases: [
                                                                    'Experiment',
                                                                    'A/B Test',
                                                                    'AB Test',
                                                                    'ABTest',
                                                                  ],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      'rgba(110, 119, 148, 0.12)',
                                                                    fontColor:
                                                                      '#6E7794',
                                                                  },
                                                                  eventTooltips:
                                                                    '#6E7794',
                                                                },
                                                              },
                                                              "showLegendDimensionIcons": true,
                                                              "showYAxisLine": false
                                                            },
                                                            "downloadConfig": {
                                                              "columns": [
                                                                {
                                                                  "code": "date",
                                                                  "name": "日期",
                                                                  "nameEn": "Date",
                                                                  "nameCn": "日期",
                                                                  "format": "yyyy-mm-dd",
                                                                  "type": "date"
                                                                },
                                                                {
                                                                  "code": "register_arpu",
                                                                  "name": "新进ARPU(当天)",
                                                                  "nameEn": "New User ARPU(Today)",
                                                                  "nameCn": "新进ARPU(当天)",
                                                                  "format": "#,##0.00"
                                                                },
                                                                {
                                                                  "code": "register_arpu_last_value",
                                                                  "name": "新进ARPU(上周同期)",
                                                                  "nameEn": "New User ARPU(Same Day Last Week)",
                                                                  "nameCn": "新进ARPU(上周同期)",
                                                                  "format": "#,##0.00"
                                                                },
                                                                {
                                                                  "code": "event",
                                                                  "dependKey": "date",
                                                                  "dateKey": "start_time",
                                                                  "name": "当天开始事件名称",
                                                                  "nameEn": "Start Event Name (Today)",
                                                                  "nameCn": "当天开始事件名称",
                                                                  "format": "@",
                                                                  "type": "event",
                                                                  "wrapText": true
                                                                },
                                                                {
                                                                  "code": "last_week_date",
                                                                  "name": "上周同期日期",
                                                                  "nameEn": "Date (same day last week)",
                                                                  "nameCn": "上周同期日期",
                                                                  "format": "yyyy-mm-dd",
                                                                  "type": "date"
                                                                },
                                                                {
                                                                  "code": "last_week_version_event",
                                                                  "dependKey": "last_week_date",
                                                                  "dateKey": "start_time",
                                                                  "name": "上周同期开始事件名称",
                                                                  "nameEn": "Start Event Name (Same Day Same Day Last Week)",
                                                                  "nameCn": "上周同期开始事件名称",
                                                                  "format": "@",
                                                                  "type": "event",
                                                                  "wrapText": true
                                                                }
                                                              ]
                                                            },
                                                            "yAxisMin": {
                                                              "enabled": false,
                                                              "minRatio": 0
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    },
                                                    {
                                                      "name": "KpiEventDimensionTrendService",
                                                      "metrics": [
                                                        "register_arpu"
                                                      ],
                                                      "anomalyMetricKey": "register_arpu",
                                                      "valueFormatRule": "thousands2Decimal",
                                                      "dimensionValueSource": "row_field",
                                                      "dimensionKey": "system",
                                                      "selectorMapKey": "system",
                                                      "accumulation": {
                                                        "by_system": true
                                                      },
                                                      "allowedOsCodes": [
                                                        "1",
                                                        "2",
                                                        "255"
                                                      ],
                                                      "dimensionSeriesOrderPriority": [
                                                        "1",
                                                        "2"
                                                      ],
                                                      "dimensionSeriesColorMap": {
                                                        "1": "#69D19C",
                                                        "2": "#5086F3"
                                                      },
                                                      "downloadIncludeLastWeek": false,
                                                      "applyKpiUaRoiUaMediaScope": true,
                                                      "children": [
                                                        {
                                                          "name": "EventMetricTrend",
                                                          "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                          "props": {
                                                            "showTableView": true,
                                                            "enableViewportOptimization": true,
                                                            "tableViewHeight": 375,
                                                            "titleEn": "New User ARPU($)",
                                                            "titleCn": "新进ARPU($)",
                                                            "chartConfig": {
                                                              "yAxisFormat": "thousands2Decimal",
                                                              "formatRule": "thousands2Decimal",
                                                              "dateFormatRule": "MM-DD",
                                                              // kpiEventUi: true,
                                                              "eventTypeDisplayOrder": [
                                                                "版更",
                                                                "UA",
                                                                "玩法",
                                                                "商业化",
                                                                "实验"
                                                              ],
                                                              "eventBubbleDetailsNav": {
                                                                "minCountExclusive": 0,
                                                                "path": "eventAnalysis/eventDetails",
                                                                "query": {
                                                                  "timeType": "Day",
                                                                  "dashboardType": "overview"
                                                                }
                                                              },
                                                              "eventBubbleItemUnderline": false,
                                                              "eventTypeBarColorMap": {
                                                                版更: {
                                                                  tagStyleAliases: ['Version'],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      'rgba(241, 158, 85, 0.12)',
                                                                    fontColor:
                                                                      '#F19E55',
                                                                  },
                                                                  eventTooltips:
                                                                    '#F19E55',
                                                                },
                                                                UA: {
                                                                  tagStyleAliases: ['UA'],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      'rgba(94, 200, 241, 0.12)',
                                                                    fontColor:
                                                                      '#5EC8F1',
                                                                  },
                                                                  eventTooltips:
                                                                    '#5EC8F1',
                                                                },
                                                                玩法: {
                                                                  tagStyleAliases: ['Gameplay'],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      '#DBF3E0',
                                                                    fontColor:
                                                                      '#1DB440',
                                                                  },
                                                                  eventTooltips:
                                                                    '#1DB440',
                                                                },
                                                                商业化: {
                                                                  tagStyleAliases: [
                                                                    'Commercialization',
                                                                    'Commercial',
                                                                  ],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      'rgba(127, 111, 241, 0.12)',
                                                                    fontColor:
                                                                      '#7F6FF1',
                                                                  },
                                                                  eventTooltips:
                                                                    '#7F6FF1',
                                                                },
                                                                实验: {
                                                                  tagStyleAliases: [
                                                                    'Experiment',
                                                                    'A/B Test',
                                                                    'AB Test',
                                                                    'ABTest',
                                                                  ],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      'rgba(110, 119, 148, 0.12)',
                                                                    fontColor:
                                                                      '#6E7794',
                                                                  },
                                                                  eventTooltips:
                                                                    '#6E7794',
                                                                },
                                                              },
                                                              "showLegendDimensionIcons": true,
                                                              "showYAxisLine": false,
                                                              "legendIconSource": "system"
                                                            },
                                                            "downloadConfig": {},
                                                            "yAxisMin": {
                                                              "enabled": false,
                                                              "minRatio": 0
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  ]
                                                }
                                              ]
                                            },
                                            {
                                              "name": "CommonCol",
                                              "props": {
                                                "w": 12
                                              },
                                              "children": [
                                                {
                                                  "name": "KpiEventMetricTrendService",
                                                  "metrics": [
                                                    "1d_ltv",
                                                    "3d_ltv",
                                                    "7d_ltv",
                                                    "14d_ltv",
                                                    "30d_ltv"
                                                  ],
                                                  "anomalyMetricKey": "ltv",
                                                  "applyKpiUaRoiUaMediaScope": true,
                                                  "children": [
                                                    {
                                                      "name": "EventMetricTrend",
                                                      "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                      "props": {
                                                        "showTableView": true,
                                                        "enableViewportOptimization": true,
                                                        "tableViewHeight": 486,
                                                        "titleEn": "LTV($)",
                                                        "titleCn": "LTV($)",
                                                        "seriesConfig": [
                                                          {
                                                            "metricKey": "1d_ltv",
                                                            "cnName": "LTV1",
                                                            "enName": "LTV1",
                                                            "color": "#5086F3",
                                                            "formatRule": "thousands2Decimal",
                                                            "dateKey": "date",
                                                            "anomalySubKey": "d1_ltv"
                                                          },
                                                          {
                                                            "metricKey": "3d_ltv",
                                                            "cnName": "LTV3",
                                                            "enName": "LTV3",
                                                            "color": "#69D19C",
                                                            "formatRule": "thousands2Decimal",
                                                            "dateKey": "date",
                                                            "anomalySubKey": "d3_ltv",
                                                            "label": {
                                                              "show": false
                                                            }
                                                          },
                                                          {
                                                            "metricKey": "7d_ltv",
                                                            "cnName": "LTV7",
                                                            "enName": "LTV7",
                                                            "color": "#6E7794",
                                                            "formatRule": "thousands2Decimal",
                                                            "dateKey": "date",
                                                            "anomalySubKey": "d7_ltv",
                                                            "label": {
                                                              "show": false
                                                            }
                                                          },
                                                          {
                                                            "metricKey": "14d_ltv",
                                                            "cnName": "LTV14",
                                                            "enName": "LTV14",
                                                            "color": "#F5D242",
                                                            "formatRule": "thousands2Decimal",
                                                            "dateKey": "date",
                                                            "anomalySubKey": "d14_ltv",
                                                            "label": {
                                                              "show": false
                                                            }
                                                          },
                                                          {
                                                            "metricKey": "30d_ltv",
                                                            "cnName": "LTV30",
                                                            "enName": "LTV30",
                                                            "color": "#7F6FF1",
                                                            "formatRule": "thousands2Decimal",
                                                            "dateKey": "date",
                                                            "anomalySubKey": "d30_ltv",
                                                            "label": {
                                                              "show": false
                                                            }
                                                          }
                                                        ],
                                                        "chartConfig": {
                                                          "yAxisFormat": "thousands2Decimal",
                                                          "formatRule": "thousands2Decimal",
                                                          "dateFormatRule": "MM-DD",
                                                          // kpiEventUi: true,
                                                          "eventTypeDisplayOrder": [
                                                            "版更",
                                                            "UA",
                                                            "玩法",
                                                            "商业化",
                                                            "实验"
                                                          ],
                                                          "eventBubbleDetailsNav": {
                                                            "minCountExclusive": 0,
                                                            "path": "eventAnalysis/eventDetails",
                                                            "query": {
                                                              "timeType": "Day",
                                                              "dashboardType": "overview"
                                                            }
                                                          },
                                                          "eventBubbleItemUnderline": false,
                                                          "eventTypeBarColorMap": {
                                                            版更: {
                                                              tagStyleAliases: ['Version'],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(241, 158, 85, 0.12)',
                                                                fontColor:
                                                                  '#F19E55',
                                                              },
                                                              eventTooltips:
                                                                '#F19E55',
                                                            },
                                                            UA: {
                                                              tagStyleAliases: ['UA'],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(94, 200, 241, 0.12)',
                                                                fontColor:
                                                                  '#5EC8F1',
                                                              },
                                                              eventTooltips:
                                                                '#5EC8F1',
                                                            },
                                                            玩法: {
                                                              tagStyleAliases: ['Gameplay'],
                                                              xAxisBubble: {
                                                                background:
                                                                  '#DBF3E0',
                                                                fontColor:
                                                                  '#1DB440',
                                                              },
                                                              eventTooltips:
                                                                '#1DB440',
                                                            },
                                                            商业化: {
                                                              tagStyleAliases: [
                                                                'Commercialization',
                                                                'Commercial',
                                                              ],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(127, 111, 241, 0.12)',
                                                                fontColor:
                                                                  '#7F6FF1',
                                                              },
                                                              eventTooltips:
                                                                '#7F6FF1',
                                                            },
                                                            实验: {
                                                              tagStyleAliases: [
                                                                'Experiment',
                                                                'A/B Test',
                                                                'AB Test',
                                                                'ABTest',
                                                              ],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(110, 119, 148, 0.12)',
                                                                fontColor:
                                                                  '#6E7794',
                                                              },
                                                              eventTooltips:
                                                                '#6E7794',
                                                            },
                                                          },
                                                          "showLegendDimensionIcons": true,
                                                          "showYAxisLine": false
                                                        },
                                                        "downloadConfig": {
                                                          "columns": [
                                                            {
                                                              "code": "date",
                                                              "name": "日期",
                                                              "nameEn": "Date",
                                                              "nameCn": "日期",
                                                              "format": "yyyy-mm-dd",
                                                              "type": "date"
                                                            },
                                                            {
                                                              "code": "1d_ltv",
                                                              "name": "LTV1",
                                                              "nameEn": "LTV1",
                                                              "nameCn": "LTV1",
                                                              "format": "#,##0.00"
                                                            },
                                                            {
                                                              "code": "3d_ltv",
                                                              "name": "LTV3",
                                                              "nameEn": "LTV3",
                                                              "nameCn": "LTV3",
                                                              "format": "#,##0.00"
                                                            },
                                                            {
                                                              "code": "7d_ltv",
                                                              "name": "LTV7",
                                                              "nameEn": "LTV7",
                                                              "nameCn": "LTV7",
                                                              "format": "#,##0.00"
                                                            },
                                                            {
                                                              "code": "14d_ltv",
                                                              "name": "LTV14",
                                                              "nameEn": "LTV14",
                                                              "nameCn": "LTV14",
                                                              "format": "#,##0.00"
                                                            },
                                                            {
                                                              "code": "30d_ltv",
                                                              "name": "LTV30",
                                                              "nameEn": "LTV30",
                                                              "nameCn": "LTV30",
                                                              "format": "#,##0.00"
                                                            },
                                                            {
                                                              "code": "event",
                                                              "dependKey": "date",
                                                              "dateKey": "start_time",
                                                              "name": "当天开始事件名称",
                                                              "nameEn": "Start Event Name (Today)",
                                                              "nameCn": "当天开始事件名称",
                                                              "format": "@",
                                                              "type": "event",
                                                              "wrapText": true
                                                            },
                                                            {
                                                              "code": "last_week_version_event",
                                                              "dependKey": "last_week_date",
                                                              "dateKey": "start_time",
                                                              "name": "上周同期开始事件名称",
                                                              "nameEn": "Start Event Name (Same Day Same Day Last Week)",
                                                              "nameCn": "上周同期开始事件名称",
                                                              "format": "@",
                                                              "type": "event",
                                                              "wrapText": true
                                                            }
                                                          ]
                                                        },
                                                        "yAxisMin": {
                                                          "enabled": false,
                                                          "minRatio": 0
                                                        }
                                                      }
                                                    }
                                                  ]
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "SegmentScrollChildrenWrapper",
                                      "id": "creative_team",
                                      "children": [
                                        {
                                          "name": "SectionHeadingWithSub",
                                          "props": {
                                            "titleCn": "素材团队",
                                            "titleEn": "Creative Team",
                                            "subTitleCn": "数据为AFID口径",
                                            "subTitleEn": "Based on AFID"
                                          }
                                        },
                                        {
                                          "name": "AiAnalysisGuard",
                                          "children": [
                                            {
                                              "name": "MarkDownCard",
                                              "className": "margin-t-20 dbd-markdown-card-title-black margin-b-20",
                                              "data": {
                                                "subtitle": ""
                                              },
                                              "props": {
                                                "titleEn": "AI Analysis",
                                                "titleCn": "AI分析总结",
                                                "titleIcon": "ai-color-robot",
                                                "content": "{{data.creative.ai_info}}",
                                                "updateDate": "{{data.creative.date}}",
                                                "subtitleEn": "{{subtitle}}",
                                                "subtitleCn": "{{subtitle}}",
                                                "infoType": "{{data.creative.ai_info_type}}",
                                                "htmlKey": "html",
                                                "linkOpenInNewWindow": true
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "name": "KpiOverviewScopeTabs",
                                          "data": {
                                            "kpiOverviewDataScope": "all"
                                          },
                                          "props": {
                                            "defaultScope": "all",
                                            "allTabLabelEn": "All",
                                            "allTabLabelCn": "全部",
                                            "uaScopeTabLabelEn": "UA-ROI Campaign & UA Media Channel",
                                            "uaScopeTabLabelCn": "UA-ROI Campaign & UA 买量渠道",
                                            "uaScopeTipEn": "Data scope: Campaign type = UA-ROI and Media Channel = UA, subject to filters.",
                                            "uaScopeTipCn": "数据口径：Campaign 类型为 UA-ROI，Media Channel 类型为 UA，受筛选器影响"
                                          },
                                          "children": [
                                            {
                                              "name": "CommonRow",
                                              "className": "margin-b-10",
                                              "children": [
                                                {
                                                  "name": "CommonCol",
                                                  "props": {
                                                    "w": 24
                                                  },
                                                  "children": [
                                                    {
                                                      "name": "KpiNaturalNewRankService",
                                                      "props": {
                                                        "applyKpiUaRoiUaMediaScope": true,
                                                        "config": {
                                                          "metrics": [
                                                            "ug_ir"
                                                          ],
                                                          "multi_sort": [
                                                            {
                                                              "sort_by": "ug_ir",
                                                              "desc": true
                                                            }
                                                          ],
                                                          "accumulation": {
                                                            "not_by_date": true,
                                                            "custom_accumulation": [
                                                              {
                                                                "key": "ua_network",
                                                                "is_accumulation": true
                                                              }
                                                            ]
                                                          },
                                                          "logical_flag": "overall_dimension_top",
                                                          "page": 1,
                                                          "page_size": 9999,
                                                          "valueMetricKey": "ug_ir",
                                                          "rankDataKey": "ivrUaNetworkRank",
                                                          "rowIconMode": "ua_channel"
                                                        }
                                                      },
                                                      "children": [
                                                        {
                                                          "name": "RankProgressListCard",
                                                          "style": {
                                                            "marginTop": "20px"
                                                          },
                                                          "props": {
                                                            "dataKey": "ivrUaNetworkRank",
                                                            "titleCn": "IVR 排名",
                                                            "titleEn": "IVR Ranking",
                                                            "className": "dbd-rank-progress-list-ivr",
                                                            "subTitleEn": "(Install/Impression)",
                                                            "subTitleCn": "(安装次数/广告展示次数)",
                                                            "rowLabelCn": "买量渠道",
                                                            "rowLabelEn": "UA Network",
                                                            "columnsByDateType": {
                                                              "singleDate": [
                                                                {
                                                                  "key": "natural_new",
                                                                  "labelCn": "IVR",
                                                                  "labelEn": "IVR",
                                                                  "sortable": true,
                                                                  "headerColumnWidth": 176,
                                                                  "columnWidth": 96,
                                                                  "badge": {
                                                                    "textCn": "北极星",
                                                                    "textEn": "北极星"
                                                                  },
                                                                  "formatRule": "percent2Decimal"
                                                                },
                                                                {
                                                                  "key": "dod",
                                                                  "labelCn": "日环比",
                                                                  "labelEn": "DoD",
                                                                  "sortable": true,
                                                                  "formatRule": "absPercent1Decimal",
                                                                  "variant": "dod"
                                                                },
                                                                {
                                                                  "key": "sdlw",
                                                                  "labelCn": "上周同期",
                                                                  "labelEn": "SDLW",
                                                                  "sortable": true,
                                                                  "formatRule": "absPercent1Decimal",
                                                                  "variant": "dod"
                                                                }
                                                              ],
                                                              "rangeDate": [
                                                                {
                                                                  "key": "natural_new",
                                                                  "labelCn": "IVR",
                                                                  "labelEn": "IVR",
                                                                  "sortable": true,
                                                                  "headerColumnWidth": 176,
                                                                  "columnWidth": 96,
                                                                  "badge": {
                                                                    "textCn": "北极星",
                                                                    "textEn": "北极星"
                                                                  },
                                                                  "formatRule": "percent2Decimal"
                                                                },
                                                                {
                                                                  "key": "change",
                                                                  "metricSourceKey": "dod",
                                                                  "labelCn": "变化率",
                                                                  "labelEn": "Change",
                                                                  "sortable": true,
                                                                  "formatRule": "absPercent1Decimal",
                                                                  "variant": "dod"
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  ]
                                                }
                                              ]
                                            },
                                            {
                                              "name": "CommonRow",
                                              "children": [
                                                {
                                                  "name": "CommonCol",
                                                  "props": {
                                                    "w": 24
                                                  },
                                                  "children": [
                                                    {
                                                      "name": "KpiEventDimensionTrendService",
                                                      "metrics": [
                                                        "ug_ir"
                                                      ],
                                                      "anomalyMetricKey": "ivr",
                                                      "logicalFlag": "show_all_data",
                                                      "topNum": 10,
                                                      "dimensionKey": "ua_network",
                                                      "selectorMapKey": "ua_network",
                                                      "accumulation": {
                                                        "custom_accumulation": [
                                                          {
                                                            "key": "ua_network",
                                                            "is_accumulation": true
                                                          }
                                                        ]
                                                      },
                                                      "valueFormatRule": "percent2Decimal",
                                                      "downloadIncludeLastWeek": false,
                                                      "applyKpiUaRoiUaMediaScope": true,
                                                      "children": [
                                                        {
                                                          "name": "EventMetricTrend",
                                                          "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                          "props": {
                                                            "showTableView": true,
                                                            "enableViewportOptimization": true,
                                                            "titleEn": "IVR",
                                                            "titleCn": "IVR",
                                                            "chartConfig": {
                                                              "yAxisFormat": "percentInt",
                                                              "formatRule": "percent2Decimal",
                                                              "dateFormatRule": "MM-DD",
                                                              // kpiEventUi: true,
                                                              "showDataLabel": true,
                                                              "eventTypeDisplayOrder": [
                                                                "版更",
                                                                "UA",
                                                                "玩法",
                                                                "商业化",
                                                                "实验"
                                                              ],
                                                              "eventBubbleDetailsNav": {
                                                                "minCountExclusive": 0,
                                                                "path": "eventAnalysis/eventDetails",
                                                                "query": {
                                                                  "timeType": "Day",
                                                                  "dashboardType": "overview"
                                                                }
                                                              },
                                                              "eventBubbleItemUnderline": false,
                                                              "eventTypeBarColorMap": {
                                                                版更: {
                                                                  tagStyleAliases: ['Version'],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      'rgba(241, 158, 85, 0.12)',
                                                                    fontColor:
                                                                      '#F19E55',
                                                                  },
                                                                  eventTooltips:
                                                                    '#F19E55',
                                                                },
                                                                UA: {
                                                                  tagStyleAliases: ['UA'],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      'rgba(94, 200, 241, 0.12)',
                                                                    fontColor:
                                                                      '#5EC8F1',
                                                                  },
                                                                  eventTooltips:
                                                                    '#5EC8F1',
                                                                },
                                                                玩法: {
                                                                  tagStyleAliases: ['Gameplay'],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      '#DBF3E0',
                                                                    fontColor:
                                                                      '#1DB440',
                                                                  },
                                                                  eventTooltips:
                                                                    '#1DB440',
                                                                },
                                                                商业化: {
                                                                  tagStyleAliases: [
                                                                    'Commercialization',
                                                                    'Commercial',
                                                                  ],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      'rgba(127, 111, 241, 0.12)',
                                                                    fontColor:
                                                                      '#7F6FF1',
                                                                  },
                                                                  eventTooltips:
                                                                    '#7F6FF1',
                                                                },
                                                                实验: {
                                                                  tagStyleAliases: [
                                                                    'Experiment',
                                                                    'A/B Test',
                                                                    'AB Test',
                                                                    'ABTest',
                                                                  ],
                                                                  xAxisBubble: {
                                                                    background:
                                                                      'rgba(110, 119, 148, 0.12)',
                                                                    fontColor:
                                                                      '#6E7794',
                                                                  },
                                                                  eventTooltips:
                                                                    '#6E7794',
                                                                },
                                                              },
                                                              "showLegendDimensionIcons": true,
                                                              "showYAxisLine": false,
                                                              "legendIconSource": "ua_network"
                                                            },
                                                            "downloadConfig": {},
                                                            "yAxisMin": {
                                                              "enabled": false,
                                                              "minRatio": 0
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  ]
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "SegmentScrollChildrenWrapper",
                                      "id": "region_team",
                                      "children": [
                                        {
                                          "name": "SectionHeadingWithSub",
                                          "props": {
                                            "titleCn": "区域团队",
                                            "titleEn": "Regional Team",
                                            "subTitleCn": "数据为AFID口径",
                                            "subTitleEn": "Based on AFID"
                                          }
                                        },
                                        {
                                          "name": "AiAnalysisGuard",
                                          "children": [
                                            {
                                              "name": "MarkDownCard",
                                              "className": "margin-t-20 dbd-markdown-card-title-black margin-b-20",
                                              "data": {
                                                "subtitle": ""
                                              },
                                              "props": {
                                                "titleEn": "AI Analysis",
                                                "titleCn": "AI分析总结",
                                                "titleIcon": "ai-color-robot",
                                                "content": "{{data.region.ai_info}}",
                                                "updateDate": "{{data.region.date}}",
                                                "subtitleEn": "{{subtitle}}",
                                                "subtitleCn": "{{subtitle}}",
                                                "infoType": "{{data.region.ai_info_type}}",
                                                "htmlKey": "html",
                                                "linkOpenInNewWindow": true
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "name": "KpiNaturalNewRankService",
                                          "props": {
                                            "config": {
                                              "metrics": [
                                                "ug_install"
                                              ],
                                              "multi_sort": [
                                                {
                                                  "sort_by": "ug_install",
                                                  "desc": true
                                                }
                                              ],
                                              "accumulation": {
                                                "not_by_date": true,
                                                "by_country": true
                                              },
                                              "logical_flag": "overall_dimension_top",
                                              "page": 1,
                                              "page_size": 9999,
                                              "valueMetricKey": "ug_install",
                                              "uaNetworkMatchType": [
                                                "Organic"
                                              ],
                                              "hideZeroOrEmptyValueMetricRows": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "RankProgressListCard",
                                              "className": "margin-b-20",
                                              "props": {
                                                "dataKey": "naturalNewRank",
                                                "titleCn": "自然新进排名",
                                                "titleEn": "Organic New User Ranking",
                                                "rowLabelCn": "国家",
                                                "rowLabelEn": "Country",
                                                "columnsByDateType": {
                                                  "singleDate": [
                                                    {
                                                      "key": "natural_new",
                                                      "labelCn": "自然新进",
                                                      "labelEn": "Organic New",
                                                      "columnWidth": 90,
                                                      "sortable": true,
                                                      "badge": {
                                                        "textCn": "北极星",
                                                        "textEn": "北极星"
                                                      },
                                                      "formatRule": "thousandsInit"
                                                    },
                                                    {
                                                      "key": "share",
                                                      "labelCn": "占比",
                                                      "labelEn": "Share",
                                                      "sortable": true,
                                                      "formatRule": "absPercent1Decimal"
                                                    },
                                                    {
                                                      "key": "dod",
                                                      "labelCn": "日环比",
                                                      "labelEn": "DoD",
                                                      "sortable": true,
                                                      "formatRule": "absPercent1Decimal",
                                                      "variant": "dod"
                                                    },
                                                    {
                                                      "key": "sdlw",
                                                      "labelCn": "上周同期",
                                                      "labelEn": "SDLW",
                                                      "sortable": true,
                                                      "formatRule": "absPercent1Decimal",
                                                      "variant": "dod"
                                                    }
                                                  ],
                                                  "rangeDate": [
                                                    {
                                                      "key": "natural_new",
                                                      "labelCn": "自然新进",
                                                      "labelEn": "Organic New",
                                                      "columnWidth": 90,
                                                      "sortable": true,
                                                      "badge": {
                                                        "textCn": "北极星",
                                                        "textEn": "北极星"
                                                      },
                                                      "formatRule": "thousandsInit"
                                                    },
                                                    {
                                                      "key": "share",
                                                      "labelCn": "占比",
                                                      "labelEn": "Share",
                                                      "sortable": true,
                                                      "formatRule": "absPercent1Decimal"
                                                    },
                                                    {
                                                      "key": "change",
                                                      "metricSourceKey": "dod",
                                                      "labelCn": "变化率",
                                                      "labelEn": "Change",
                                                      "sortable": true,
                                                      "formatRule": "absPercent1Decimal",
                                                      "variant": "dod"
                                                    }
                                                  ]
                                                }
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "name": "CommonRow",
                                          "className": "margin-b-10",
                                          "children": [
                                            {
                                              "name": "CommonCol",
                                              "props": {
                                                "w": 24
                                              },
                                              "children": [
                                                {
                                                  "name": "KpiEventDimensionTrendService",
                                                  "metrics": [
                                                    "ug_install"
                                                  ],
                                                  "anomalyMetricKey": "organic_new_user",
                                                  "logicalFlag": "show_all_data",
                                                  "topNum": 10,
                                                  "accumulation": {
                                                    "by_country": true
                                                  },
                                                  "dimensionKey": "country",
                                                  "dimensionValueSource": "row_field",
                                                  "selectorMapKey": "country",
                                                  "valueFormatRule": "thousandsInit",
                                                  "uaNetworkMatchType": [
                                                    "Organic"
                                                  ],
                                                  "downloadIncludeLastWeek": false,
                                                  "children": [
                                                    {
                                                      "name": "EventMetricTrend",
                                                      "className": "dbd-pubg-dau-version-change-analysis-trend",
                                                      "props": {
                                                        "showTableView": true,
                                                        "enableViewportOptimization": true,
                                                        "titleEn": "Organic New",
                                                        "titleCn": "自然新进",
                                                        "chartConfig": {
                                                          "yAxisFormat": "bmk",
                                                          "formatRule": "thousandsInit",
                                                          "dateFormatRule": "MM-DD",
                                                          "showDataLabel": true,
                                                          // "kpiEventUi": true,
                                                          "eventTypeDisplayOrder": [
                                                            "版更",
                                                            "UA",
                                                            "玩法",
                                                            "商业化",
                                                            "实验"
                                                          ],
                                                          "eventBubbleDetailsNav": {
                                                            "minCountExclusive": 0,
                                                            "path": "eventAnalysis/eventDetails",
                                                            "query": {
                                                              "timeType": "Day",
                                                              "dashboardType": "overview"
                                                            }
                                                          },
                                                          "eventBubbleItemUnderline": false,
                                                          "eventTypeBarColorMap": {
                                                            版更: {
                                                              tagStyleAliases: ['Version'],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(241, 158, 85, 0.12)',
                                                                fontColor:
                                                                  '#F19E55',
                                                              },
                                                              eventTooltips:
                                                                '#F19E55',
                                                            },
                                                            UA: {
                                                              tagStyleAliases: ['UA'],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(94, 200, 241, 0.12)',
                                                                fontColor:
                                                                  '#5EC8F1',
                                                              },
                                                              eventTooltips:
                                                                '#5EC8F1',
                                                            },
                                                            玩法: {
                                                              tagStyleAliases: ['Gameplay'],
                                                              xAxisBubble: {
                                                                background:
                                                                  '#DBF3E0',
                                                                fontColor:
                                                                  '#1DB440',
                                                              },
                                                              eventTooltips:
                                                                '#1DB440',
                                                            },
                                                            商业化: {
                                                              tagStyleAliases: [
                                                                'Commercialization',
                                                                'Commercial',
                                                              ],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(127, 111, 241, 0.12)',
                                                                fontColor:
                                                                  '#7F6FF1',
                                                              },
                                                              eventTooltips:
                                                                '#7F6FF1',
                                                            },
                                                            实验: {
                                                              tagStyleAliases: [
                                                                'Experiment',
                                                                'A/B Test',
                                                                'AB Test',
                                                                'ABTest',
                                                              ],
                                                              xAxisBubble: {
                                                                background:
                                                                  'rgba(110, 119, 148, 0.12)',
                                                                fontColor:
                                                                  '#6E7794',
                                                              },
                                                              eventTooltips:
                                                                '#6E7794',
                                                            },
                                                          },
                                                          "showLegendDimensionIcons": true,
                                                          "showYAxisLine": false,
                                                          "legendIconSource": "country"
                                                        },
                                                        "downloadConfig": {},
                                                        "yAxisMin": {
                                                          "enabled": false,
                                                          "minRatio": 0
                                                        }
                                                      }
                                                    }
                                                  ]
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};